webpackJsonp([76],{

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hub = new _vue2.default();

exports.default = Hub;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(389);

var _vuex2 = _interopRequireDefault(_vuex);

var _logger = __webpack_require__(890);

var _logger2 = _interopRequireDefault(_logger);

var _account = __webpack_require__(444);

var _account2 = _interopRequireDefault(_account);

var _auth = __webpack_require__(454);

var _auth2 = _interopRequireDefault(_auth);

var _master = __webpack_require__(469);

var _master2 = _interopRequireDefault(_master);

var _search = __webpack_require__(484);

var _search2 = _interopRequireDefault(_search);

var _home = __webpack_require__(464);

var _home2 = _interopRequireDefault(_home);

var _broker = __webpack_require__(459);

var _broker2 = _interopRequireDefault(_broker);

var _socket = __webpack_require__(489);

var _socket2 = _interopRequireDefault(_socket);

var _users = __webpack_require__(494);

var _users2 = _interopRequireDefault(_users);

var _auctioneer = __webpack_require__(449);

var _auctioneer2 = _interopRequireDefault(_auctioneer);

var _rm = __webpack_require__(474);

var _rm2 = _interopRequireDefault(_rm);

var _saleshead = __webpack_require__(479);

var _saleshead2 = _interopRequireDefault(_saleshead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var debug = "production" !== 'production';

exports.default = new _vuex2.default.Store({
  modules: {
    account: _account2.default,
    auth: _auth2.default,
    master: _master2.default,
    search: _search2.default,
    home: _home2.default,
    broker: _broker2.default,
    socket: _socket2.default,
    auctioneer: _auctioneer2.default,
    users: _users2.default,
    rm: _rm2.default,
    saleshead: _saleshead2.default
  },

  strict: debug,

  plugins: debug ? [(0, _logger2.default)()] : []
});

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(176);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(393);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(177);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(178);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorageService = function () {
  function StorageService() {
    (0, _classCallCheck3.default)(this, StorageService);
  }

  (0, _createClass3.default)(StorageService, null, [{
    key: 'setSessionData',
    value: function setSessionData(key, value) {
      if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') sessionStorage.setItem(key, (0, _stringify2.default)(value));else sessionStorage.setItem(key, '' + value);
    }
  }, {
    key: 'getSessionData',
    value: function getSessionData(key) {
      var value = '';
      try {
        value = JSON.parse(sessionStorage.getItem(key));
      } catch (e) {
        value = '' + sessionStorage.getItem(key);
      }
      return value;
    }
  }]);
  return StorageService;
}();

exports.default = StorageService;

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STORE = exports.STORE = 'STORE';
var SOCK = exports.SOCK = 'SOCK';
var SOCKET_CLOSE = exports.SOCKET_CLOSE = 'SOCKET_CLOSE';
var MYPROJECTS = exports.MYPROJECTS = 'MYPROJECTS';
var MYACTIVITY = exports.MYACTIVITY = 'MYACTIVITY';
var MYPAYMENTS = exports.MYPAYMENTS = 'MYPAYMENTS';
var RESET = exports.RESET = 'RESET';

exports.default = {
  STORE: STORE,
  SOCK: SOCK,
  SOCKET_CLOSE: SOCKET_CLOSE,
  MYPROJECTS: MYPROJECTS,
  MYACTIVITY: MYACTIVITY,
  MYPAYMENTS: MYPAYMENTS,
  RESET: RESET
};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GETAUCTIONEERLIVE = exports.GETAUCTIONEERLIVE = 'GETAUCTIONEERLIVE';
var UPDATEAUCTIONEERLIVE = exports.UPDATEAUCTIONEERLIVE = 'UPDATEAUCTIONEERLIVE';
var GETINVENTORYPROJECTDETAILS = exports.GETINVENTORYPROJECTDETAILS = 'GETINVENTORYPROJECTDETAILS';

exports.default = {
  GETAUCTIONEERLIVE: GETAUCTIONEERLIVE,
  UPDATEAUCTIONEERLIVE: UPDATEAUCTIONEERLIVE,
  GETINVENTORYPROJECTDETAILS: GETINVENTORYPROJECTDETAILS
};

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CHECK = exports.CHECK = 'CHECK';
var LOGIN = exports.LOGIN = 'LOGIN';
var LOGOUT = exports.LOGOUT = 'LOGOUT';
var UPDATEBROKERCUSTOMERS = exports.UPDATEBROKERCUSTOMERS = 'UPDATEBROKERCUSTOMERS';
var ADDBROKERCUSTOMER = exports.ADDBROKERCUSTOMER = 'ADDBROKERCUSTOMER';
var PROFILESAVE = exports.PROFILESAVE = 'PROFILESAVE';
var UPDATEVERIFIED = exports.UPDATEVERIFIED = 'UPDATEVERIFIED';
var UPDATEFAV = exports.UPDATEFAV = 'UPDATEFAV';
var SETUSERINFO = exports.SETUSERINFO = 'SETUSERINFO';

exports.default = {
  CHECK: CHECK,
  LOGIN: LOGIN,
  LOGOUT: LOGOUT,
  UPDATEBROKERCUSTOMERS: UPDATEBROKERCUSTOMERS,
  ADDBROKERCUSTOMER: ADDBROKERCUSTOMER,
  PROFILESAVE: PROFILESAVE,
  UPDATEVERIFIED: UPDATEVERIFIED,
  UPDATEFAV: UPDATEFAV,
  SETUSERINFO: SETUSERINFO
};

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FAVOURITES = exports.FAVOURITES = 'FAVOURITES';
var CUSTOMERTOKEN = exports.CUSTOMERTOKEN = 'CUSTOMERTOKEN';
var MYFAVOURITES = exports.MYFAVOURITES = 'MYFAVOURITES';
var MYPROJECTS = exports.MYPROJECTS = 'MYPROJECTS';
var LIVEPROJECTS = exports.LIVEPROJECTS = 'LIVEPROJECTS';
var MYCUSTOMERS = exports.MYCUSTOMERS = 'MYCUSTOMERS';
var MYADDEDCUSTOMERS = exports.MYADDEDCUSTOMERS = 'MYADDEDCUSTOMERS';
var EDITADDEDCUSTOMERS = exports.EDITADDEDCUSTOMERS = 'EDITADDEDCUSTOMERS';
var BUILDERS = exports.BUILDERS = 'BUILDERS';
var RESET = exports.RESET = 'RESET';

exports.default = {
  FAVOURITES: FAVOURITES,
  CUSTOMERTOKEN: CUSTOMERTOKEN,
  MYFAVOURITES: MYFAVOURITES,
  MYPROJECTS: MYPROJECTS,
  LIVEPROJECTS: LIVEPROJECTS,
  MYCUSTOMERS: MYCUSTOMERS,
  MYADDEDCUSTOMERS: MYADDEDCUSTOMERS,
  EDITADDEDCUSTOMERS: EDITADDEDCUSTOMERS,
  BUILDERS: BUILDERS,
  RESET: RESET
};

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HOME = exports.HOME = 'HOME';
var FAVPROJECTS = exports.FAVPROJECTS = 'FAVPROJECTS';
var ADDFAVPROJECTS = exports.ADDFAVPROJECTS = 'ADDFAVPROJECTS';
var DELETEFAVPROJECTS = exports.DELETEFAVPROJECTS = 'DELETEFAVPROJECTS';
var PROJECTDETAILS = exports.PROJECTDETAILS = 'PROJECTDETAILS';
var GETNOTIFICATIONS = exports.GETNOTIFICATIONS = 'GETNOTIFICATIONS';
var UPDATENOTIFICATIONS = exports.UPDATENOTIFICATIONS = 'UPDATENOTIFICATIONS';
var ADDNOTIFICATIONS = exports.ADDNOTIFICATIONS = 'ADDNOTIFICATIONS';
var UPDATEBID = exports.UPDATEBID = 'UPDATEBID';
var FOOTERPROJECTS = exports.FOOTERPROJECTS = 'FOOTERPROJECTS';
var GETBIDSTRENGTH = exports.GETBIDSTRENGTH = 'GETBIDSTRENGTH';
var LOCALITIES = exports.LOCALITIES = 'LOCALITIES';
var TAGS = exports.TAGS = 'TAGS';
var RESET = exports.RESET = 'RESET';
var SETOVERLAYSTATE = exports.SETOVERLAYSTATE = 'SETOVERLAYSTATE';
var SHOWWONLOSTBID = exports.SHOWWONLOSTBID = 'SHOWWONLOSTBID';
var SHOWAUCTIONLOST = exports.SHOWAUCTIONLOST = 'SHOWAUCTIONLOST';
var SITEDRM = exports.SITEDRM = 'SITEDRM';
var SETCITY = exports.SETCITY = 'SETCITY';
var SETCOMPAREDATA = exports.SETCOMPAREDATA = 'SETCOMPAREDATA';
var SETPROJECTLIST = exports.SETPROJECTLIST = 'SETPROJECTLIST';
var SETUNITDETAILS = exports.SETUNITDETAILS = 'SETUNITDETAILS';
var ADDFAVUNITS = exports.ADDFAVUNITS = 'ADDFAVUNITS';
var DELETEFAVUNITS = exports.DELETEFAVUNITS = 'DELETEFAVUNITS';
var GETLISTINGDATA = exports.GETLISTINGDATA = 'GETLISTINGDATA';
var UPDATEPROJECT = exports.UPDATEPROJECT = 'UPDATEPROJECT';
var UPDATESTATS = exports.UPDATESTATS = 'UPDATESTATS';
var UPDATEUNITS = exports.UPDATEUNITS = 'UPDATEUNITS';
var UPDATEFAVUNITSIGNAL = exports.UPDATEFAVUNITSIGNAL = 'UPDATEFAVUNITSIGNAL';
var REMOVESOLDUNIT = exports.REMOVESOLDUNIT = 'REMOVESOLDUNIT';

exports.default = {
  HOME: HOME,
  FAVPROJECTS: FAVPROJECTS,
  ADDFAVPROJECTS: ADDFAVPROJECTS,
  DELETEFAVPROJECTS: DELETEFAVPROJECTS,
  PROJECTDETAILS: PROJECTDETAILS,
  GETNOTIFICATIONS: GETNOTIFICATIONS,
  ADDNOTIFICATIONS: ADDNOTIFICATIONS,
  UPDATENOTIFICATIONS: UPDATENOTIFICATIONS,
  UPDATEBID: UPDATEBID,
  FOOTERPROJECTS: FOOTERPROJECTS,
  GETBIDSTRENGTH: GETBIDSTRENGTH,
  LOCALITIES: LOCALITIES,
  TAGS: TAGS,
  RESET: RESET,
  SETOVERLAYSTATE: SETOVERLAYSTATE,
  SHOWWONLOSTBID: SHOWWONLOSTBID,
  SHOWAUCTIONLOST: SHOWAUCTIONLOST,
  SITEDRM: SITEDRM,
  SETCITY: SETCITY,
  SETCOMPAREDATA: SETCOMPAREDATA,
  SETPROJECTLIST: SETPROJECTLIST,
  SETUNITDETAILS: SETUNITDETAILS,
  ADDFAVUNITS: ADDFAVUNITS,
  DELETEFAVUNITS: DELETEFAVUNITS,
  GETLISTINGDATA: GETLISTINGDATA,
  UPDATEPROJECT: UPDATEPROJECT,
  UPDATESTATS: UPDATESTATS,
  UPDATEUNITS: UPDATEUNITS,
  UPDATEFAVUNITSIGNAL: UPDATEFAVUNITSIGNAL,
  REMOVESOLDUNIT: REMOVESOLDUNIT
};

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MASTER = exports.MASTER = 'MASTER';
var CALCULATESOLDUNITS = exports.CALCULATESOLDUNITS = 'CALCULATESOLDUNITS';
var UPDATEPROJECT = exports.UPDATEPROJECT = 'UPDATEPROJECT';
var ADDPROJECT = exports.ADDPROJECT = 'ADDPROJECT';
var SETLOADER = exports.SETLOADER = 'SETLOADER';
var INTERNALMASTER = exports.INTERNALMASTER = 'INTERNALMASTER';

exports.default = {
  MASTER: MASTER,
  CALCULATESOLDUNITS: CALCULATESOLDUNITS,
  UPDATEPROJECT: UPDATEPROJECT,
  ADDPROJECT: ADDPROJECT,
  SETLOADER: SETLOADER,
  INTERNALMASTER: INTERNALMASTER
};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MYCUSTOMERS = exports.MYCUSTOMERS = 'MYCUSTOMERS';
var MYBROKERS = exports.MYBROKERS = 'MYBROKERS';
var MYPROJECTS = exports.MYPROJECTS = 'MYPROJECTS';
var GETRM = exports.GETRM = 'GETRM';
var RMLIVEDETAILS = exports.RMLIVEDETAILS = 'RMLIVEDETAILS';
var UPDATERMBROKER = exports.UPDATERMBROKER = 'UPDATERMBROKER';
var UPDATERMLIVEDETAILS = exports.UPDATERMLIVEDETAILS = 'UPDATERMLIVEDETAILS';
var UPDATERMCUSTOMER = exports.UPDATERMCUSTOMER = 'UPDATERMCUSTOMER';
var UPDATERMPROJECT = exports.UPDATERMPROJECT = 'UPDATERMPROJECT';
var DRMBROKERS = exports.DRMBROKERS = 'DRMBROKERS';

exports.default = {
  MYCUSTOMERS: MYCUSTOMERS,
  MYBROKERS: MYBROKERS,
  MYPROJECTS: MYPROJECTS,
  DRMBROKERS: DRMBROKERS,
  GETRM: GETRM,
  RMLIVEDETAILS: RMLIVEDETAILS,
  UPDATERMLIVEDETAILS: UPDATERMLIVEDETAILS,
  UPDATERMBROKER: UPDATERMBROKER,
  UPDATERMPROJECT: UPDATERMPROJECT
};

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MYCUSTOMERS = exports.MYCUSTOMERS = 'MYCUSTOMERS';
var MYPROJECTS = exports.MYPROJECTS = 'MYPROJECTS';
var MYBROKERS = exports.MYBROKERS = 'MYBROKERS';
var BROKERLISTWITHDRM = exports.BROKERLISTWITHDRM = 'BROKERLISTWITHDRM';

exports.default = {
  MYCUSTOMERS: MYCUSTOMERS,
  MYPROJECTS: MYPROJECTS,
  MYBROKERS: MYBROKERS,
  BROKERLISTWITHDRM: BROKERLISTWITHDRM
};

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INITIAL = exports.INITIAL = 'INITIAL';
var INITIALDETAILS = exports.INITIALDETAILS = 'INITIALDETAILS';
var SELECTEDSEARCH = exports.SELECTEDSEARCH = 'SELECTEDSEARCH';

exports.default = {
  INITIAL: INITIAL,
  INITIALDETAILS: INITIALDETAILS,
  SELECTEDSEARCH: SELECTEDSEARCH
};

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONNECT = exports.CONNECT = 'CONNECT';
var SENDDATA = exports.SENDDATA = 'SENDDATA';
var HANDLEDATA = exports.HANDLEDATA = 'HANDLEDATA';
var DISCONNECT = exports.DISCONNECT = 'DISCONNECT';

exports.default = {
  CONNECT: CONNECT,
  SENDDATA: SENDDATA,
  HANDLEDATA: HANDLEDATA,
  DISCONNECT: DISCONNECT
};

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USERS = exports.USERS = 'USERS';
var PROJECTRMDETAILS = exports.PROJECTRMDETAILS = 'PROJECTRMDETAILS';
var BROKERAPPROVALS = exports.BROKERAPPROVALS = 'BROKERAPPROVALS';
var CUSTOMERSANDBROKERSLIST = exports.CUSTOMERSANDBROKERSLIST = 'CUSTOMERSANDBROKERSLIST';
var DRMLIST = exports.DRMLIST = 'DRMLIST';
var DEVLIST = exports.DEVLIST = 'DEVLIST';
var OTHERUSER = exports.OTHERUSER = 'OTHERUSER';
var STOREFORMULADATA = exports.STOREFORMULADATA = 'STOREFORMULADATA';
var REMOVEFORMULADATA = exports.REMOVEFORMULADATA = 'REMOVEFORMULADATA';

exports.default = {
  USERS: USERS,
  PROJECTRMDETAILS: PROJECTRMDETAILS,
  BROKERAPPROVALS: BROKERAPPROVALS,
  CUSTOMERSANDBROKERSLIST: CUSTOMERSANDBROKERSLIST,
  DRMLIST: DRMLIST,
  STOREFORMULADATA: STOREFORMULADATA,
  REMOVEFORMULADATA: REMOVEFORMULADATA,
  DEVLIST: DEVLIST,
  OTHERUSER: OTHERUSER
};

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTER = exports.REGISTER = '/account/register/';
var BROKERREGISTER = exports.BROKERREGISTER = '/broker/register/';
var BROKEREDIT = exports.BROKEREDIT = '/broker/edit/';
var BROKERVERIFY = exports.BROKERVERIFY = '/broker/verify/';
var NOTIFY = exports.NOTIFY = '/account/save-email/';
var LOGININTERNAL = exports.LOGININTERNAL = '/account/login-internal/';
var LOGINCUSTOMER = exports.LOGINCUSTOMER = '/account/login-customer/';
var BROKERLOGINCUSTOMER = exports.BROKERLOGINCUSTOMER = '/broker/logincustomer/';
var FORGOT = exports.FORGOT = '/account/forgot-password/';
var FORGOTCHANGEPASSWORD = exports.FORGOTCHANGEPASSWORD = '/account/change-password/';
var CHANGE = exports.CHANGE = '/account/change-customer-password/';
var MYSITEVISITS = exports.MYSITEVISITS = '/account/site-visit-details/';
var NEARBY = exports.NEARBY = '/project/nearby/';
var MYPROFILE = exports.MYPROFILE = '/account/customer-settings/';
var GETBROKERFAVOURITES = exports.GETBROKERFAVOURITES = '/account/get-broker-user-favourites/';
var BROKERACCOUNT = exports.BROKERACCOUNT = '/account/broker-user/';
var MYPROJECTS = exports.MYPROJECTS = '/account/get-user-projects/';
var REFERRAL = exports.REFERRAL = '/account/add-referral/';
var CONTACTUS = exports.CONTACTUS = '/account/contact-us/';
var ADDNOTE = exports.ADDNOTE = '/account/add-note/';
var LOGOUT = exports.LOGOUT = '/account/logout/';
var SENDOTP = exports.SENDOTP = '/account/send-otp/';
var VERIFYOTP = exports.VERIFYOTP = '/account/verify-otp/';
var ADDPHONE = exports.ADDPHONE = '/account/add-phone/';
var VERIFYEMAIL = exports.VERIFYEMAIL = '/account/verify-email/';
var ABORTBOOKING = exports.ABORTBOOKING = '/auction/booking-aborted/';
var RESENDEMAIL = exports.RESENDEMAIL = '/account/resend-email/';
var GETUSERINFO = exports.GETUSERINFO = '/account/getuserinfo/';
var WITHDRAWBID = exports.WITHDRAWBID = '/auction/bid/bid-id/withdraw/';
var SURVEY = exports.SURVEY = '/account/survey/';

var HOME = exports.HOME = '/project/v1/home/';
var PROJECTMASTER = exports.PROJECTMASTER = '/project/v1/internal-master/';
var STATISTICS = exports.STATISTICS = '/project/statistics/';
var SITEVISIT = exports.SITEVISIT = '/project/sitevisit/';
var PROJECTDETAILS = exports.PROJECTDETAILS = '/project/v1/project-details/';
var UNITDETAILS = exports.UNITDETAILS = '/project/v1/project-details/id/units/';
var BUILDERDETAILS = exports.BUILDERDETAILS = '/project/builder-details/';
var PROJECTFAVOURITE = exports.PROJECTFAVOURITE = '/project/my-favourites/';
var COMPARE = exports.COMPARE = '/project/compare/';
var GETBUILDERS = exports.GETBUILDERS = '/project/get-all-builders/';
var ADDINVENTORY = exports.ADDINVENTORY = '/project/inventory/';
var FOOTERPROJECTS = exports.FOOTERPROJECTS = '/project/get-locality-data/';
var GETLOCALITIES = exports.GETLOCALITIES = '/project/get-new-project-locality-data/';
var GETTAGS = exports.GETTAGS = '/project/get-tag-data/';
var GETEXCLUSIVEPROJECTS = exports.GETEXCLUSIVEPROJECTS = '/project/exclusive-projects/';
var GETUNITCOST = exports.GETUNITCOST = '/project/get-unit-additional-cost/';
var GETDEVLIST = exports.GETDEVLIST = '/project/get-developers-list/';
var GETCOMPAREPROJECT = exports.GETCOMPAREPROJECT = '/project/compare-projects/';
var GETPROJECTLIST = exports.GETPROJECTLIST = '/project/project-list/';

var SEARCH = exports.SEARCH = '/project/search/';
var SEARCHDETAILS = exports.SEARCHDETAILS = '/project/search/details/';

var MYACTIVITY = exports.MYACTIVITY = '/internal/my-activity/';
var USERS = exports.USERS = '/internal/users/';
var OTHERUSEERS = exports.OTHERUSEERS = '/internal/get-non-internal-users/';
var BROKERAPPROVALS = exports.BROKERAPPROVALS = '/broker/approvals/';
var BROKERREMARK = exports.BROKERREMARK = '/broker/remark/';
var BROKERSITEVISIT = exports.BROKERSITEVISIT = '/broker/sitevisit/';
var GETUNITDETAILS = exports.GETUNITDETAILS = '/project/get-unit-details/';
var DELETEUNIT = exports.DELETEUNIT = '/project/unit/';
var GETINVENTORYPROJECTDETAILS = exports.GETINVENTORYPROJECTDETAILS = '/project/get-project-details-for-inventory/';
var INTERNALNOTIFICATIONS = exports.INTERNALNOTIFICATIONS = '/account/internal-notification-settings/';
var PROJECTRMDETAILS = exports.PROJECTRMDETAILS = '/internal/rm-details-for-project/';
var UPDATERMSTATUS = exports.UPDATERMSTATUS = '/internal/update-rm-active-status/';
var CUSTOMERSANDBROKERSLIST = exports.CUSTOMERSANDBROKERSLIST = '/account/getcustomers/';
var AGENTCUSTOMERS = exports.AGENTCUSTOMERS = '/internal/customer-details-for-agent/';
var AGENTRMS = exports.AGENTRMS = '/internal/rm-details-of-project-for-agent/';
var GETDRMLIST = exports.GETDRMLIST = '/internal/get-drm-list/';
var GETFORMULAE = exports.GETFORMULAE = '/project/get-all-formula-fields/';

var RMASSIGN = exports.RMASSIGN = '/rm/assign/';
var RMCUSTOMERS = exports.RMCUSTOMERS = '/rm/customer-list/';
var RMBROKERS = exports.RMBROKERS = '/rm/broker-list/';
var PASTAUCTIONS = exports.PASTAUCTIONS = '/rm/past-auctions/';
var BIDDETAILS = exports.BIDDETAILS = '/rm/bid-details/';
var RMLIVE = exports.RMLIVE = '/rm/live/';
var RMPROJECTS = exports.RMPROJECTS = '/rm/projects/';
var RMADDNOTE = exports.RMADDNOTE = '/rm/add-note/';
var GETRM = exports.GETRM = '/internal/rms/';
var CUSTOMERCHEQUE = exports.CUSTOMERCHEQUE = '/project/cheque-image-upload/';
var INCREASETIME = exports.INCREASETIME = '/auction/extend-time-for-payment-for-customer/';

var VERIFYPROJECT = exports.VERIFYPROJECT = '/project/verify/';
var EDITANDVERIFY = exports.EDITANDVERIFY = '/project/inventory-edit-and-verify/';

var SHCUSTOMERS = exports.SHCUSTOMERS = '/sales-head/get-customer-broker-list/';
var SHBROKERS = exports.SHBROKERS = 'sales-head/broker-list/';
var SHPROJECTS = exports.SHPROJECTS = '/sales-head/projects/';
var BROKERLISTWITHDRM = exports.BROKERLISTWITHDRM = '/broker/all/';
var EDITDRM = exports.EDITDRM = '/sales-head/edit-drm/';

var CLOSEAUCTION = exports.CLOSEAUCTION = '/auction/close-auction/';
var DROPPRICE = exports.DROPPRICE = '/auction/drop-price/';
var GETAUCTION = exports.GETAUCTION = '/auction/edit-auction-popup/';
var GETVALUELISTING = exports.GETVALUELISTING = '/auction/value-listing-popup/';
var EDITAUCTION = exports.EDITAUCTION = '/auction/schedule-auction/';
var AUCTIONEERLIVE = exports.AUCTIONEERLIVE = '/auction/auctioneer-live/';
var VALUELISTING = exports.VALUELISTING = '/auction/value-listing/';

var BROKERPROJECTS = exports.BROKERPROJECTS = '/broker/projects/';
var LIVEPROJECTS = exports.LIVEPROJECTS = '/project/live-project-list/';
var BROKERFAVOURITES = exports.BROKERFAVOURITES = '/broker/favourite/';
var BROKERCUSTOMERS = exports.BROKERCUSTOMERS = '/broker/customers/';
var BROKERADDCUSTOMERS = exports.BROKERADDCUSTOMERS = '/broker/addcustomer/';
var BROKERCUSTOMERUPLOAD = exports.BROKERCUSTOMERUPLOAD = '/broker/customerupload/';
var BROKERADDEDCUSTOMERS = exports.BROKERADDEDCUSTOMERS = '/broker/myaddedcustomers/';
var BROKEREDITCUSTOMERS = exports.BROKEREDITCUSTOMERS = '/broker/editcustomer/';
var BROKERCUSTOMERBID = exports.BROKERCUSTOMERBID = 'broker/assigncustomer/';

var DRMBROKERS = exports.DRMBROKERS = '/internal/drm-broker-list/';

var BID = exports.BID = '/auction/bid/';
var AUCTIONVALUELISTING = exports.AUCTIONVALUELISTING = '/auction/value-listing/';
var BOOK = exports.BOOK = '/auction/book/';
var BULKINVENTORY = exports.BULKINVENTORY = '/project/bulk-inventory/';
var PROJECTIMAGE = exports.PROJECTIMAGE = '/project/project-image/';
var RELEASEUNIT = exports.RELEASEUNIT = '/rm/release-unit/';
var RESERVEUNIT = exports.RESERVEUNIT = '/rm/reserve-unit/';
var DELETERESERVEUNIT = exports.DELETERESERVEUNIT = '/rm/delete-reserve-unit-image/';
var CHANGERESERVEUNITSTATUS = exports.CHANGERESERVEUNITSTATUS = '/auction/change-reserve-unit-status/';
var SENDPAYMENTLINK = exports.SENDPAYMENTLINK = '/payment/send-payment-link/';
var PAUSEAUCTION = exports.PAUSEAUCTION = '/auction/pause-auction/';
var UNPAUSEAUCTION = exports.UNPAUSEAUCTION = 'auction/unpause-auction/';
var SETPAYMENTTIME = exports.SETPAYMENTTIME = '/auction/change-time-for-payment/';

var GETNOTIFICATIONS = exports.GETNOTIFICATIONS = '/notification/get/';
var EDITNOTIFICATIONS = exports.EDITNOTIFICATIONS = '/notification/update/';

var PAYMENTDETAILS = exports.PAYMENTDETAILS = '/payment/get-details/';
var PAYMENTCHECKOUT = exports.PAYMENTCHECKOUT = '/payment/checkout/';
var MYPAYMENTS = exports.MYPAYMENTS = '/payment/soa/';
var CANCELBOOKING = exports.CANCELBOOKING = '/payment/cancel-booking/';
var INVOICE = exports.INVOICE = 'payment/invoice/';
var GETBIDSTRENGTH = exports.GETBIDSTRENGTH = '/auction/get-bid-strength/';

var CALL = exports.CALL = '/calling/call/';

var CAREER = exports.CAREER = '/account/career/';

var loaderLessAPIs = exports.loaderLessAPIs = [PROJECTFAVOURITE, GETBROKERFAVOURITES];

var guestMapping = exports.guestMapping = [PROJECTDETAILS, FORGOT, FORGOTCHANGEPASSWORD, NEARBY, REFERRAL, CONTACTUS, HOME, CAREER, STATISTICS, COMPARE, FOOTERPROJECTS, SEARCH, SEARCHDETAILS, GETBIDSTRENGTH, GETLOCALITIES, GETUNITCOST, GETPROJECTLIST, GETCOMPAREPROJECT, UNITDETAILS];

exports.default = {
  REGISTER: REGISTER,
  BROKERREGISTER: BROKERREGISTER,
  BROKEREDIT: BROKEREDIT,
  BROKERVERIFY: BROKERVERIFY,
  NOTIFY: NOTIFY,
  LOGINCUSTOMER: LOGINCUSTOMER,
  LOGININTERNAL: LOGININTERNAL,
  FORGOT: FORGOT,
  CHANGE: CHANGE,
  HOME: HOME,
  CAREER: CAREER,
  PROJECTMASTER: PROJECTMASTER,
  STATISTICS: STATISTICS,
  SITEVISIT: SITEVISIT,
  MYSITEVISITS: MYSITEVISITS,
  SEARCH: SEARCH,
  SEARCHDETAILS: SEARCHDETAILS,
  NEARBY: NEARBY,
  PROJECTDETAILS: PROJECTDETAILS,
  BUILDERDETAILS: BUILDERDETAILS,
  MYPROFILE: MYPROFILE,
  PROJECTFAVOURITE: PROJECTFAVOURITE,
  RMASSIGN: RMASSIGN,
  COMPARE: COMPARE,
  BROKERPROJECTS: BROKERPROJECTS,
  LIVEPROJECTS: LIVEPROJECTS,
  GETBROKERFAVOURITES: GETBROKERFAVOURITES,
  BROKERFAVOURITES: BROKERFAVOURITES,
  BROKERACCOUNT: BROKERACCOUNT,
  BROKERCUSTOMERS: BROKERCUSTOMERS,
  BROKERADDCUSTOMERS: BROKERADDCUSTOMERS,
  BROKERADDEDCUSTOMERS: BROKERADDEDCUSTOMERS,
  BROKERCUSTOMERBID: BROKERCUSTOMERBID,
  USERS: USERS,
  RMCUSTOMERS: RMCUSTOMERS,
  RMBROKERS: RMBROKERS,
  BID: BID,
  PASTAUCTIONS: PASTAUCTIONS,
  RMLIVE: RMLIVE,
  AUCTIONEERLIVE: AUCTIONEERLIVE,
  EDITAUCTION: EDITAUCTION,
  CLOSEAUCTION: CLOSEAUCTION,
  DROPPRICE: DROPPRICE,
  CALL: CALL,
  REFERRAL: REFERRAL,
  GETFORMULAE: GETFORMULAE,
  GETUNITCOST: GETUNITCOST,
  guestMapping: guestMapping,
  loaderLessAPIs: loaderLessAPIs,
  RESENDEMAIL: RESENDEMAIL,
  GETCOMPAREPROJECT: GETCOMPAREPROJECT,
  UNITDETAILS: UNITDETAILS,
  WITHDRAWBID: WITHDRAWBID
};

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(179);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(177);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(178);

var _createClass3 = _interopRequireDefault(_createClass2);

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiService = function () {
  function ApiService() {
    (0, _classCallCheck3.default)(this, ApiService);
  }

  (0, _createClass3.default)(ApiService, null, [{
    key: 'setLoader',
    value: function setLoader() {
      _store2.default.dispatch('master/setLoaderState', true);
    }
  }, {
    key: 'removeLoader',
    value: function removeLoader() {
      _store2.default.dispatch('master/setLoaderState', false);
    }
  }, {
    key: 'post',
    value: function post(url, requestData) {
      var _this = this;

      var p = new _promise2.default(function (resolve, reject) {
        var noLoader = _endpoint.loaderLessAPIs.filter(function (m) {
          return m.includes(url);
        });
        if (!(noLoader && noLoader.length)) _this.setLoader();
        _vue2.default.$http.post(url, requestData).then(function (data) {
          _this.removeLoader();
          setTimeout(function () {
            resolve(data.data);
          }, 300);
        }).catch(function (error) {
          _this.removeLoader();
          setTimeout(function () {
            reject(error.response.data);
          }, 300);
        });
      });
      return p;
    }
  }, {
    key: 'get',
    value: function get(url, requestparams, _removeHeader) {
      var _this2 = this;

      var p = new _promise2.default(function (resolve, reject) {
        var noLoader = _endpoint.loaderLessAPIs.filter(function (m) {
          return m.includes(url);
        });
        if (!(noLoader && noLoader.length)) _this2.setLoader();
        _vue2.default.$http.get(url, {
          params: requestparams
        }).then(function (data) {
          _this2.removeLoader();
          setTimeout(function () {
            resolve(data.data);
          }, 300);
        }).catch(function (error) {
          _this2.removeLoader();
          setTimeout(function () {
            reject(error.response.data);
          }, 300);
        });
      });
      return p;
    }
  }, {
    key: 'put',
    value: function put(url, requestData) {
      var _this3 = this;

      var p = new _promise2.default(function (resolve, reject) {
        _this3.setLoader();
        _vue2.default.$http.put(url, requestData).then(function (data) {
          _this3.removeLoader();
          setTimeout(function () {
            resolve(data.data);
          }, 300);
        }).catch(function (error) {
          _this3.removeLoader();
          setTimeout(function () {
            reject(error.response.data);
          }, 300);
        });
      });
      return p;
    }
  }, {
    key: 'delete',
    value: function _delete(url, requestparams) {
      var _this4 = this;

      var p = new _promise2.default(function (resolve, reject) {
        var noLoader = _endpoint.loaderLessAPIs.filter(function (m) {
          return m.includes(url);
        });
        if (!(noLoader && noLoader.length)) _this4.setLoader();
        _vue2.default.$http.delete('' + url + requestparams + '/').then(function (data) {
          _this4.removeLoader();
          setTimeout(function () {
            resolve(data.data);
          }, 300);
        }).catch(function (error) {
          _this4.removeLoader();
          setTimeout(function () {
            reject(error.response.data);
          }, 300);
        });
      });
      return p;
    }
  }, {
    key: 'deleteWithParams',
    value: function deleteWithParams(url, requestparams) {
      var _this5 = this;

      var p = new _promise2.default(function (resolve, reject) {
        var noLoader = _endpoint.loaderLessAPIs.filter(function (m) {
          return m.includes(url);
        });
        if (!(noLoader && noLoader.length)) _this5.setLoader();
        _vue2.default.$http.delete(url, { params: requestparams }).then(function (data) {
          _this5.removeLoader();
          setTimeout(function () {
            resolve(data.data);
          }, 300);
        }).catch(function (error) {
          _this5.removeLoader();
          setTimeout(function () {
            reject(error.response.data);
          }, 300);
        });
      });
      return p;
    }
  }]);
  return ApiService;
}();

exports.default = ApiService;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(90);

var _vueLazyload = __webpack_require__(863);

var _vueLazyload2 = _interopRequireDefault(_vueLazyload);

var _app = __webpack_require__(864);

var _app2 = _interopRequireDefault(_app);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 898));

_vue2.default.config.productionTip = false;
_vue2.default.use(_vueLazyload2.default, {
  lazyComponent: true
});

document.addEventListener('DOMContentLoaded', function () {
  __webpack_require__(440);
  __webpack_require__(437);
  __webpack_require__(439);
  __webpack_require__(438);
  __webpack_require__(436);

  new _vue2.default({
    el: '#app',

    router: _vueRouter.router,
    store: _store2.default,
    render: function render(h) {
      return h(_app2.default);
    }
  });
});

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _socketActionMapping = __webpack_require__(434);

var _socketActionMapping2 = _interopRequireDefault(_socketActionMapping);

var _regex = __webpack_require__(433);

var _regex2 = _interopRequireDefault(_regex);

var _strings = __webpack_require__(435);

var _strings2 = _interopRequireDefault(_strings);

var _common = __webpack_require__(432);

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  socketActionMapping: _socketActionMapping2.default,
  regex: _regex2.default,
  strings: _strings2.default,
  common: _common2.default
};

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  specificBidAmount: 500,
  cutOffBidAmount: 25000,
  bidFee: 500,
  bookingFee: 50000,
  cdn: 'https://watabid-static.imgix.net',
  countryCode: [{
    country: 'India +91',
    codes: '+91',
    minDigit: 10,
    maxDigit: 10
  }, {
    country: 'Singapore +65',
    codes: '+65',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Australia +61',
    codes: '+61',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'US or Canada +1',
    codes: '+1',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Malaysia +60',
    codes: '+60',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'UAE +971',
    codes: '+971',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Bahrain +973',
    codes: '+973',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Iraq +964',
    codes: '+964',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Kuwait +965',
    codes: '+965',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Oman +968',
    codes: '+968',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Qatar +974',
    codes: '+974',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Saudi Arabia +966',
    codes: '+966',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'UK +44',
    codes: '+44',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Germany +49',
    codes: '+49',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'New Zealand +64',
    codes: '+64',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'France +33',
    codes: '+33',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Switzerland +41',
    codes: '+41',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'South Africa +27',
    codes: '+27',
    minDigit: 7,
    maxDigit: 12
  }, {
    country: 'Spain +34',
    codes: '+34',
    minDigit: 7,
    maxDigit: 12
  }],
  totalFavUnits: 10
};

exports.default = common;

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var regex = {
  phone: /^$|^[56789]\d{9}$/
};

exports.default = regex;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mapping = {
  update_project: 'home/updateProject',
  update_unit: 'home/updateUnit',
  update_notification: 'home/addNotifications',
  update_statistics: 'home/updateStats',
  bid_won_lost: 'home/showWonLostBid',
  update_bid: 'home/updateBid',
  update_locality: 'home/updateLocality',
  update_internal_master: 'master/updateInternalMaster',
  update_auctioneer_live: 'auctioneer/updateAuctioneerLive',
  update_rm_live: 'rm/updateRmLive',
  update_rm_customer: 'rm/updateRmCustomer',
  update_rm_projects: 'rm/updateRmProject',
  update_broker_list: 'rm/updateRmBroker',
  update_favourite: 'auth/updateFav',
  update_favourite_unit: 'home/updateFavUnitSignal',
  remove_sold_unit: 'home/removeSoldUnit'
};

exports.default = mapping;

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var strings = {
  specific_bid: 'Flexi Bid',
  cut_off_bid: 'Cut Off Bid',
  amenities: ['swimming_pool', 'club_house', 'children_play_area', 'basket_ball_practice_pitch', 'tennis_court', 'badminton_court', 'football_ground', 'gymnasium', 'jogging_track', 'indoor_games', 'video_security', 'amphitheatre', 'art_and_craft_studio', 'indoor_squash_court', 'barbeque_pit', 'coffee_lounge', 'dance_studio', 'cycle_track', 'spa', 'lobby_garden', 'home_automation', 'super_market', 'rcc_sumps_sewage_and_overhead_tank', 'security_room', 'intercom', 'pharmacy', 'power_back_up', 'land_scape_area', 'day_care_centre', 'meditation_centre', 'cricket_practice_pitch', 'organic_farm', 'air_purifier', 'skating__court', 'senior_citizen_sitting_area', 'golf_course', 'passenger_and_service_lift', 'access_ramp_for_physicaly_challenged', 'steam_room', 'sauna_room', 'massage_room', 'mini_theatre', 'digital_gaming_zone', 'table_tennis', 'atm', 'laundry_and_dry_cleaners', 'library', 'outdoor_exercise_area_with_equipments', 'common_toilet__for_servant_and_drivers', 'pick_up_and_drop_off_point', 'car_parking', 'park', 'volley_ball', 'multipurpose_court', 'half_basket_ball_court', 'beach_volley_ball', 'kids_play_area', 'outdoor_socializing_space', 'yoga_deck', 'toddlers_pool', 'banquet_lawn', 'pantry'],
  takeAQuizAmenities: ['gas_pipeline', 'gymnasium', 'swimming_pool', 'passenger_and_service_lift', 'car_parking', 'power_back_up', 'park'],
  unitTypes: [{ id: 'APARTMENT', name: 'Apartment' }, { id: 'INDEPENDENT_HOUSE', name: 'Independent House' }, { id: 'INDEPENDENT_FLOOR', name: 'Independent Floor' }, { id: 'STUDIO', name: 'Studio' }, { id: 'DUPLEX', name: 'Duplex' }, { id: 'PENTHOUSE', name: 'Penthouse' }, { id: 'ROW_HOUSE', name: 'Row House' }]

};

exports.default = strings;

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.filter('round', function (value, decimals) {
  if (value) value = parseFloat(value).toFixed(decimals);
  return value;
});

_vue2.default.filter('doubleDigit', function (value) {
  if (value === 'G') return value;
  return parseInt(value, 10).toLocaleString(undefined, { minimumIntegerDigits: 2 });
});

_vue2.default.filter('date', function (date) {
  if (date) return (0, _moment2.default)(date).format('DD-MM-YYYY');
  return date;
});

_vue2.default.filter('activity_date', function (date) {
  if (date) {
    var dateObj = new Date(date);
    return dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate() + ', ' + dateObj.getHours() + ':' + dateObj.getMinutes() + ':' + dateObj.getSeconds();
  }
  return date;
});

_vue2.default.filter('timestamp_date', function (date) {
  if (date) {
    var dateObj = new Date(date * 1000);
    return dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate();
  }
  return date;
});

_vue2.default.filter('currencyFormatter', function (value) {
  if (value) {
    value = parseFloat(value);
    var modifiedVal = value.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return modifiedVal;
  }
  return value;
});

_vue2.default.filter('currencyFormatterNoDecimal', function (value) {
  if (value) {
    value = parseFloat(value);
    var modifiedVal = value.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    return modifiedVal;
  }
  return value;
});

_vue2.default.filter('notificationTime', function (d) {
  var now = (0, _moment2.default)(new Date());
  var months = now.diff(d, 'months');
  var days = now.diff(d, 'days');
  var hours = now.diff(d, 'hours');
  var minutes = now.diff(d, 'minutes');
  if (months > 0) return months + 'mon';else if (days > 0) return days + 'd';else if (hours > 0) return hours + 'hr';
  return minutes + 'min';
});

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(179);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(414);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.baseURL = "https://backend.watabid.com/api/";
_axios2.default.defaults.headers.common.Accept = 'application/json';
_axios2.default.interceptors.request.use(function (config) {
  var isGuestAPI = false;
  if (localStorage.getItem('is_internal') === 'true') {
    _endpoint.guestMapping.forEach(function (m) {
      if (config.url.includes(m)) isGuestAPI = true;
    });
  }
  if (isGuestAPI && localStorage.getItem('is_internal') === 'true') return config;

  if (localStorage.getItem('access_token')) {
    if (_store2.default.state.broker.customerAccessToken !== '') config.headers.Authorization = 'Bearer ' + _store2.default.state.broker.customerAccessToken;else config.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token');
  }
  return config;
}, function (err) {
  return _promise2.default.reject(err);
});
_axios2.default.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 500) window.location = '/error';
  if (error.response.status === 401) {
    _store2.default.dispatch('auth/logout', {
      cbSuccess: function cbSuccess() {
        setTimeout(function () {
          window.location = '?login=true';
        }, 300);
      }
    });
  }if (error.response.status === 503) _store2.default.dispatch('auctioneer/showAuctionPausedStatus', true);
  return _promise2.default.reject(error);
});

_vue2.default.$http = _axios2.default;
Object.defineProperty(_vue2.default.prototype, '$http', {
  get: function get() {
    return _axios2.default;
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vueFacebookSigninButton = __webpack_require__(858);

var _vueFacebookSigninButton2 = _interopRequireDefault(_vueFacebookSigninButton);

var _vuetify = __webpack_require__(888);

var _vuetify2 = _interopRequireDefault(_vuetify);

var _veeValidate = __webpack_require__(856);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueHead = __webpack_require__(859);

var _vueHead2 = _interopRequireDefault(_vueHead);

var _jquery = __webpack_require__(411);

var _jquery2 = _interopRequireDefault(_jquery);

var _vueCarousel = __webpack_require__(407);

var _vueCarousel2 = _interopRequireDefault(_vueCarousel);

var _vueHighcharts = __webpack_require__(862);

var _vueHighcharts2 = _interopRequireDefault(_vueHighcharts);

var _vueScrollto = __webpack_require__(879);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _vueClipboard = __webpack_require__(857);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

var _vue2GoogleMaps = __webpack_require__(887);

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

var _vueSocialSharing = __webpack_require__(880);

var _vueSocialSharing2 = _interopRequireDefault(_vueSocialSharing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 897));


_vue2.default.use(_vueSocialSharing2.default);
_vue2.default.config.debug = "production" !== 'production';
_vue2.default.use(_vueFacebookSigninButton2.default);
_vue2.default.use(_vuetify2.default);
_vue2.default.use(_veeValidate2.default, {
  events: 'input'
});
_vue2.default.use(_vueHead2.default);
_vue2.default.use(_vueCarousel2.default);
_vue2.default.use(_vueHighcharts2.default);
_vue2.default.use(_vueScrollto2.default);
_vue2.default.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAoU9dsy6d4DPec27dIlZK-3yDq-QWOHJA',
    libraries: 'places',
    loadGoogleApi: false
  }
});
_vue2.default.use(_vueClipboard2.default);
window.$ = window.jQuery = _jquery2.default;

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vuexRouterSync = __webpack_require__(889);

var _vuexRouterSync2 = _interopRequireDefault(_vuexRouterSync);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _vueRouter = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vuexRouterSync2.default.sync(_store2.default, _vueRouter.router);

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(389);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: '',
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 914));
  },
  children: [{
    path: 'wonlost',
    name: 'home.wonlost',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 965));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: '',
    name: 'home.index',
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 913));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'career',
    name: 'home.career',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 906));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'project-list',
    name: 'home.projectList',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 964));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'mobile-test',
    name: 'home.mobileTest',
    component: __webpack_require__(865),
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'developer/:id/:name',
    name: 'home.developer',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 909));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'compareproject',
    name: 'home.compareProjects',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 907));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'compareunit',
    name: 'home.compareUnits',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 412));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'compare-unit',
    name: 'home.compare-unit',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 412));
    },
    meta: {
      guest: true,
      auth: false
    }
  }, {
    path: 'about',
    name: 'home.about',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 905));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'educate',
    name: 'home.educate',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 910));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'contact',
    name: 'home.contact',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 908));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'exclusive',
    name: 'home.exclusive',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 911));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: false
    }
  }, {
    path: 'privacy-policy',
    name: 'home.privacypolicy',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 917));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'tnc',
    name: 'home.tnc',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 919));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'tnc-cp',
    name: 'home.tnc-cp',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 918));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'faq',
    name: 'home.faq',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 912));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }, {
    path: 'verify-email',
    name: 'home.verify-email',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 920));
    },
    meta: {
      guest: true,
      auth: false,
      noMaster: true
    }
  }],

  meta: {
    guest: true,
    auth: false
  }
}, {
  path: '/payforbid',
  name: 'payforbid',
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 962));
  },
  meta: {
    guest: true,
    auth: false
  }
}, {
  path: '/internal',
  name: 'internal',
  component: function component() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 959));
  },
  children: [{
    path: 'employee',
    name: 'internal.employee',
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 940));
    },
    children: [{
      path: 'inventory',
      name: 'internal.employee.inventory',
      component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 941));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'account',
    name: 'internal.account',
    component: function component() {
      return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 921));
    },
    children: [{
      path: 'manage-notifications',
      name: 'internal.account.manageNotifications',
      component: function component() {
        return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 922));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-activity',
      name: 'internal.account.myActivity',
      component: function component() {
        return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 924));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-account',
      name: 'internal.account.myAccount',
      component: function component() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 923));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {

    path: 'admin',
    name: 'internal.admin',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 925));
    },
    children: [{
      path: 'roles-and-permissions',
      name: 'internal.admin.rolesAndPermissions',
      component: function component() {
        return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 927));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-approvals',
      name: 'internal.admin.myApprovals',
      component: function component() {
        return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 926));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'bd',
    name: 'internal.bd',
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 933));
    },
    children: [{
      path: 'edit-inventory-list',
      name: 'internal.bd.editInventoryList',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 413));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'add-inventory',
      name: 'internal.bd.addInventory',
      component: function component() {
        return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 942));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'verify-inventory',
      name: 'internal.bd.verifyInventory',
      component: function component() {
        return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 413));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'rm',
    name: 'internal.rm',
    component: function component() {
      return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 947));
    },
    children: [{
      path: 'my-projects',
      name: 'internal.rm.myProjects',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 949));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-customers',
      name: 'internal.rm.myCustomers',
      component: function component() {
        return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 948));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'broker',
    name: 'internal.broker',
    component: function component() {
      return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 934));
    },
    children: [{
      path: 'my-projects',
      name: 'internal.broker.myProjects',
      component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 937));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-customers',
      name: 'internal.broker.myCustomers',
      component: function component() {
        return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 936));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-added-customers',
      name: 'internal.broker.myAddedCustomers',
      component: function component() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 935));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'sh',
    name: 'internal.sh',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 953));
    },
    children: [{
      path: 'my-projects',
      name: 'internal.sh.myProjects',
      component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 956));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-customers',
      name: 'internal.sh.myCustomers',
      component: function component() {
        return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 955));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'my-brokers',
      name: 'internal.sh.myBrokers',
      component: function component() {
        return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 954));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'assign-rm',
      name: 'internal.sh.assignRM',
      component: function component() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 951));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'edit-drm',
      name: 'internal.sh.editDRM',
      component: function component() {
        return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 952));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'assign-project-to-customer',
      name: 'internal.sh.assignProjectToCustomer',
      component: function component() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 950));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'drm',
    name: 'internal.drm',
    component: function component() {
      return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 938));
    },
    children: [{
      path: 'my-brokers',
      name: 'internal.drm.myBrokers',
      component: function component() {
        return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 939));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'agent',
    name: 'internal.agent',
    component: function component() {
      return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 929));
    },
    children: [{
      path: 'assign-project',
      name: 'internal.agent.assignProject',
      component: function component() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 928));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'auctioneer',
    name: 'internal.auctioneer',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 931));
    },
    children: [{
      path: 'schedule',
      name: 'internal.auctioneer.schedule',
      component: function component() {
        return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 932));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }, {
      path: 'auctions',
      name: 'internal.auctioneer.auctions',
      component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 930));
      },
      meta: {
        auth: true,
        isInternal: true
      }
    }],
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'live-project/',
    name: 'internal.liveProject',
    props: true,
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 946));
    },
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'live-auction/',
    name: 'internal.liveAuction',
    props: true,
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 945));
    },
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'edit-inventory/:id',
    name: 'internal.editInventory',
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 943));
    },
    props: true,
    meta: {
      auth: true,
      isInternal: true
    }
  }, {
    path: 'verify-inventory/:id',
    name: 'internal.verifyInventory',
    component: function component() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 944));
    },
    props: true,
    meta: {
      auth: true,
      isInternal: true
    }
  }],
  meta: {
    auth: true,
    isInternal: true
  }
}, {
  path: '/internal/login',
  name: 'internal.login',
  component: function component() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 960));
  },

  meta: {
    guest: true,
    auth: false,
    isInternal: true,
    noMaster: true
  }
}, {
  path: '/internal/forgot-password',
  name: 'internal.forgot',
  component: function component() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 958));
  },

  meta: {
    guest: true,
    auth: false,
    isInternal: true,
    noMaster: true
  }
}, {
  path: '/internal/change-password',
  name: 'internal.change',
  component: function component() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 961));
  },

  meta: {
    guest: true,
    auth: false,
    isInternal: true,
    noMaster: true
  }
}, {
  path: '/internal/channel-partner-signup',
  name: 'internal.channelPartnerSignup',
  component: function component() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 957));
  },

  meta: {
    guest: true,
    auth: false,
    isInternal: true,
    noMaster: true
  }
}, {
  path: '/customer',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 900));
  },
  children: [{
    path: 'my-favourite',
    name: 'customer.favourite',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 894));
    },
    meta: {
      guest: false,
      auth: true
    }
  }, {
    path: 'my-profile',
    name: 'customer.profile',
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 902));
    },
    meta: {
      guest: false,
      auth: true
    }
  }, {
    path: 'my-projects',
    name: 'customer.project',
    component: function component() {
      return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 896));
    },
    meta: {
      guest: false,
      auth: true
    }
  }, {
    path: 'my-customers',
    name: 'customer.mycustomers',
    component: function component() {
      return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 901));
    },
    meta: {
      guest: false,
      auth: true
    }
  }, {
    path: 'my-payments',
    name: 'customer.mypayments',
    component: function component() {
      return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 895));
    },
    meta: {
      guest: false,
      auth: true
    }
  }],

  meta: {
    guest: false,
    auth: true
  }
}, {
  path: '/payment',
  name: 'payment',
  component: function component() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 963));
  },
  meta: {
    guest: false,
    auth: true
  }
}, {
  path: '/',
  name: 'comingsoon.index',
  component: function component() {
    return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 899));
  },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/sign-up',
  name: 'signup',
  component: function component() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 184));
  },
  props: { component: 'sign-up' },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/site-visit',
  name: 'sitevisit',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 184));
  },
  props: { component: 'site-visit' },

  meta: {
    guest: true,
    auth: false
  }
}, {
  path: '/add-phone',
  name: 'addphone',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 184));
  },
  props: { component: 'add-phone' },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/error',
  name: 'error',
  component: function component() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 903));
  },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/survey',
  name: 'survey',
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 904));
  },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/mobile-test',
  name: 'mobile-test',
  component: function component() {
    return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 915));
  },

  meta: {
    guest: true,
    auth: false,
    noMaster: true
  }
}, {
  path: '/:slug',
  name: 'home.projectdetails',
  component: function component() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 916));
  },
  meta: {
    guest: true,
    auth: false
  }
}, {
  path: '/*',
  redirect: '/'
}];

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(191);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var store = function store(_ref, payload) {
  var commit = _ref.commit;

  commit(types.STORE, payload);
};

var getMyProjects = function getMyProjects(_ref2) {
  var commit = _ref2.commit;

  _commonApi2.default.get(_endpoint.MYPROJECTS).then(function (response) {
    commit(types.MYPROJECTS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var getMyPayments = function getMyPayments(_ref3) {
  var commit = _ref3.commit;

  _commonApi2.default.get(_endpoint.MYPAYMENTS).then(function (response) {
    commit(types.MYPAYMENTS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var getMyActivity = function getMyActivity(_ref4) {
  var commit = _ref4.commit;

  _commonApi2.default.get(_endpoint.MYACTIVITY).then(function (response) {
    commit(types.MYACTIVITY, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var resetToDefaultState = function resetToDefaultState(_ref5) {
  var commit = _ref5.commit;

  commit(types.RESET);
};

exports.default = {
  store: store,
  getMyProjects: getMyProjects,
  getMyActivity: getMyActivity,
  getMyPayments: getMyPayments,
  resetToDefaultState: resetToDefaultState
};

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(442);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(443);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(445);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(446);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _STORE$MYPROJECTS$MYA;

var _mutationTypes = __webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_STORE$MYPROJECTS$MYA = {}, (0, _defineProperty3.default)(_STORE$MYPROJECTS$MYA, _mutationTypes.STORE, function (state, account) {
  state.email = account.email;
  state.firstName = account.firstName;
  state.lastName = account.lastName;
}), (0, _defineProperty3.default)(_STORE$MYPROJECTS$MYA, _mutationTypes.MYPROJECTS, function (state, payload) {
  state.myProjects = payload;
}), (0, _defineProperty3.default)(_STORE$MYPROJECTS$MYA, _mutationTypes.MYACTIVITY, function (state, payload) {
  state.myActivity = payload;
}), (0, _defineProperty3.default)(_STORE$MYPROJECTS$MYA, _mutationTypes.MYPAYMENTS, function (state, payload) {
  state.myPayments = payload;
}), (0, _defineProperty3.default)(_STORE$MYPROJECTS$MYA, _mutationTypes.RESET, function (state) {
  state.email = null;
  state.firstName = null;
  state.lastName = null;
  state.myProjects = [];
  state.myActivity = [];
  state.myPayments = [];
}), _STORE$MYPROJECTS$MYA);

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  email: null,
  firstName: null,
  lastName: null,
  myProjects: [],
  myActivity: [],
  myPayments: []
};

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(192);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

var _hub = __webpack_require__(113);

var _hub2 = _interopRequireDefault(_hub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  getAuctioneerLive: function getAuctioneerLive(_ref, auctionId) {
    var commit = _ref.commit;

    _commonApi2.default.get('' + _endpoint.AUCTIONEERLIVE + auctionId + '/').then(function (response) {
      commit(types.GETAUCTIONEERLIVE, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  updateAuctioneerLive: function updateAuctioneerLive(_ref2, payload) {
    var commit = _ref2.commit;

    commit(types.UPDATEAUCTIONEERLIVE, payload);
  },
  showAuctionPausedStatus: function showAuctionPausedStatus(_ref3, payload) {
    var _commit = _ref3._commit;

    if (payload) {
      _hub2.default.$emit('open-modal');
      _hub2.default.$emit('set-modal-data', {
        onlyMessage: true,
        message: 'All auctions are paused. Please try again later!'
      }, 'confirmation');
    }
  },
  getInventoryDetails: function getInventoryDetails(_ref4, projectId) {
    var commit = _ref4.commit;

    _commonApi2.default.get('' + _endpoint.GETINVENTORYPROJECTDETAILS + projectId + '/').then(function (response) {
      commit(types.GETINVENTORYPROJECTDETAILS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  setPaymentTime: function setPaymentTime(_ref5, payload) {
    var _commit = _ref5._commit;

    var data = {
      time_for_payment: payload.time_payment
    };
    _commonApi2.default.put(_endpoint.SETPAYMENTTIME + payload.auction_id + '/', data).then(function () {
      payload.cb_success();
    }).catch(function (error) {
      console.log(error);
      payload.cb_error();
    });
  }
};

exports.default = actions;

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(447);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(448);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(450);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(451);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _GETAUCTIONEERLIVE$UP;

var _mutationTypes = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_GETAUCTIONEERLIVE$UP = {}, (0, _defineProperty3.default)(_GETAUCTIONEERLIVE$UP, _mutationTypes.GETAUCTIONEERLIVE, function (state, payload) {
  state.auctioneerLive = payload;
}), (0, _defineProperty3.default)(_GETAUCTIONEERLIVE$UP, _mutationTypes.UPDATEAUCTIONEERLIVE, function (state, payload) {
  if ('' + state.auctioneerLive.auction_id === '' + payload.auction_id) state.auctioneerLive = payload;
}), (0, _defineProperty3.default)(_GETAUCTIONEERLIVE$UP, _mutationTypes.GETINVENTORYPROJECTDETAILS, function (state, payload) {
  state.inventoryDetails = payload;
}), _GETAUCTIONEERLIVE$UP);

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  auctioneerLive: null,
  inventoryDetails: null
};

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginCustomer = exports.deleteFavProjects = exports.addFavProjects = exports.resendVerifiactionMail = exports.updateVerifiedState = exports.saveProfile = exports.addBrokerCustomer = exports.updateBrokerCustomers = exports.logout = exports.login = exports.check = undefined;

var _mutationTypes = __webpack_require__(193);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

var _ = __webpack_require__(12);

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var check = exports.check = function check(_ref) {
  var commit = _ref.commit;

  commit(types.CHECK);
};

var login = exports.login = function login(_ref2, payload) {
  var commit = _ref2.commit;

  commit(types.LOGIN, payload);
  _2.default.dispatch('auth/getUserInfo');
};

var logout = exports.logout = function logout(_ref3, payload) {
  var commit = _ref3.commit;

  _commonApi2.default.post(_endpoint.LOGOUT).then(function () {
    commit(types.LOGOUT);
    if (payload && payload.cbSuccess) payload.cbSuccess();
  }).catch(function (error) {
    commit(types.LOGOUT);
    if (payload && payload.cbSuccess) payload.cbSuccess();
    console.log(error);
  });
};

var updateBrokerCustomers = exports.updateBrokerCustomers = function updateBrokerCustomers(_ref4, payload) {
  var commit = _ref4.commit;

  commit(types.UPDATEBROKERCUSTOMERS, payload);
};

var addBrokerCustomer = exports.addBrokerCustomer = function addBrokerCustomer(_ref5, payload) {
  var commit = _ref5.commit;

  commit(types.ADDBROKERCUSTOMER, payload);
};

var saveProfile = exports.saveProfile = function saveProfile(_ref6, payload) {
  var commit = _ref6.commit;

  commit(types.PROFILESAVE, payload);
};

var updateVerifiedState = exports.updateVerifiedState = function updateVerifiedState(_ref7, payload) {
  var commit = _ref7.commit;

  commit(types.UPDATEVERIFIED, payload);
};

var resendVerifiactionMail = exports.resendVerifiactionMail = function resendVerifiactionMail(_ref8, payload) {
  var _commit = _ref8._commit;

  _commonApi2.default.post(_endpoint.RESENDEMAIL, { email: payload.email }).then(function () {
    payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};
var addFavProjects = exports.addFavProjects = function addFavProjects(_ref9, payload) {
  var _commit = _ref9._commit;

  _commonApi2.default.post(_endpoint.PROJECTFAVOURITE, payload.data).then(function () {
    if (payload.cb_success) payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
  });
};
var deleteFavProjects = exports.deleteFavProjects = function deleteFavProjects(_ref10, payload) {
  var _commit = _ref10._commit;

  _commonApi2.default.deleteWithParams(_endpoint.PROJECTFAVOURITE, payload.data).then(function () {
    if (payload.cb_success) payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
  });
};

var loginCustomer = exports.loginCustomer = function loginCustomer(_ref11, payload) {
  var commit = _ref11.commit;

  _commonApi2.default.post(_endpoint.BROKERLOGINCUSTOMER, payload.data).then(function (data) {
    commit(types.LOGIN, data);
    if (payload && payload.cbSuccess) payload.cbSuccess(data);
  }).catch(function (error) {
    if (payload && payload.cbError) payload.cbError(error);
    console.log(error);
  });
};

var updateFav = function updateFav(_ref12, payload) {
  var commit = _ref12.commit;

  commit(types.UPDATEFAV, payload);
};

var getUserInfo = function getUserInfo(_ref13) {
  var commit = _ref13.commit;

  _commonApi2.default.get(_endpoint.GETUSERINFO).then(function (response) {
    commit(types.SETUSERINFO, response);
  }).catch(function (error) {
    console.log(error);
  });
};

exports.default = {
  check: check,
  login: login,
  logout: logout,
  updateBrokerCustomers: updateBrokerCustomers,
  addBrokerCustomer: addBrokerCustomer,
  saveProfile: saveProfile,
  updateVerifiedState: updateVerifiedState,
  resendVerifiactionMail: resendVerifiactionMail,
  addFavProjects: addFavProjects,
  deleteFavProjects: deleteFavProjects,
  loginCustomer: loginCustomer,
  updateFav: updateFav,
  getUserInfo: getUserInfo
};

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(452);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(453);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(455);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(456);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(176);

var _stringify2 = _interopRequireDefault(_stringify);

var _CHECK$LOGIN$LOGOUT$U;

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _mutationTypes = __webpack_require__(193);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_CHECK$LOGIN$LOGOUT$U = {}, (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.CHECK, function (state) {
  state.authenticated = !!localStorage.getItem('access_token');
  if (localStorage.getItem('is_broker')) state.isBroker = localStorage.getItem('is_broker') === 'true';
  if (localStorage.getItem('is_internal')) state.isInternal = localStorage.getItem('is_internal') === 'true';
  if (localStorage.getItem('is_verified')) state.isVerified = localStorage.getItem('is_verified') === 'true';
  if (localStorage.getItem('name')) state.name = localStorage.getItem('name');
  if (localStorage.getItem('id')) state.id = localStorage.getItem('id');
  if (localStorage.getItem('phone')) state.phone = localStorage.getItem('phone');
  if (localStorage.getItem('country_code')) state.countryCode = localStorage.getItem('country_code');
  if (localStorage.getItem('permissions') !== 'undefined' && localStorage.getItem('permissions')) state.permissions = JSON.parse(localStorage.getItem('permissions'));
  if (localStorage.getItem('bd_uploaded_projects') !== 'undefined' && localStorage.getItem('bd_uploaded_projects')) state.projects = JSON.parse(localStorage.getItem('bd_uploaded_projects'));
  if (localStorage.getItem('broker_customers_data') !== 'undefined' && localStorage.getItem('broker_customers_data')) state.brokerCustomersData = JSON.parse(localStorage.getItem('broker_customers_data')).payload;
  if (localStorage.getItem('fbid') !== 'undefined' && localStorage.getItem('fbid')) state.fbid = localStorage.getItem('fbid');
  if (localStorage.getItem('googleProfileImage') !== 'undefined' && localStorage.getItem('googleProfileImage')) state.googleProfileImage = localStorage.getItem('googleProfileImage');
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.LOGIN, function (state, payload) {
  state.authenticated = true;
  state.isInternal = !!payload.permissions;
  state.brokerCustomersData = payload.broker_customers_data;
  state.permissions = payload.permissions;
  state.bdUploadedProjects = payload.bd_uploaded_projects;
  state.id = payload.id;
  localStorage.setItem('permissions', (0, _stringify2.default)(payload.permissions));
  localStorage.setItem('bd_uploaded_projects', (0, _stringify2.default)(payload.bd_uploaded_projects));
  localStorage.setItem('access_token', payload.access_token);
  localStorage.setItem('is_internal', !!payload.permissions);
  localStorage.setItem('broker_customers_data', (0, _stringify2.default)({ payload: payload.broker_customers_data }));
  if (payload.project_id) localStorage.setItem('open_project_id', payload.project_id);
  if (payload.bid_amount) localStorage.setItem('open_bid_amount', payload.bid_amount);
  if (payload.dev_id) localStorage.setItem('dev_id', payload.dev_id);

  if (payload.referral_code) localStorage.setItem('referral_code', payload.referral_code);
  if (payload.company_name) localStorage.setItem('company_name', payload.company_name);
  if (payload.rera_no) localStorage.setItem('rera_no', payload.rera_no);
  localStorage.setItem('id', payload.id);
  _store2.default.dispatch('socket/disconnect');
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.LOGOUT, function (state) {
  state.authenticated = false;
  state.isBroker = false;
  state.isInternal = false;
  _store2.default.state.home.projectDetails = null;
  state.name = null;
  state.phone = null;
  state.id = null;
  state.bdUploadedProjects = null;
  state.favHomeProject = [];
  localStorage.removeItem('access_token');
  localStorage.removeItem('is_broker');
  localStorage.removeItem('is_internal');
  localStorage.removeItem('broker_customers_data');
  localStorage.removeItem('permissions');
  localStorage.removeItem('name');
  localStorage.removeItem('phone');
  localStorage.removeItem('id');
  localStorage.removeItem('dev_id');
  localStorage.removeItem('fav_home_project');
  if (localStorage.getItem('open_project_id')) localStorage.removeItem('open_project_id');
  if (localStorage.getItem('open_bid_amount')) localStorage.removeItem('open_bid_amount');
  if (localStorage.getItem('referral_code')) localStorage.removeItem('referral_code');
  _store2.default.dispatch('account/resetToDefaultState');
  _store2.default.dispatch('home/resetToDefaultState');
  _store2.default.dispatch('broker/resetToDefaultState');
  _store2.default.dispatch('socket/disconnect');
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.UPDATEBROKERCUSTOMERS, function (state, payload) {
  var objIndex = state.brokerCustomersData.findIndex(function (obj) {
    return String(obj.id) === String(payload.id);
  });
  state.brokerCustomersData[objIndex].customer_name = payload.customer_name;
  localStorage.setItem('broker_customers_data', (0, _stringify2.default)({ payload: state.brokerCustomersData }));
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.ADDBROKERCUSTOMER, function (state, payload) {
  state.brokerCustomersData.push(payload);
  localStorage.setItem('broker_customers_data', (0, _stringify2.default)({ payload: state.brokerCustomersData }));
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.PROFILESAVE, function (state, payload) {
  if (payload.name) {
    state.name = payload.name;
    localStorage.setItem('name', payload.name);
  }
  if (payload.phone) {
    state.phone = payload.phone;
    localStorage.setItem('phone', payload.phone);
  }
  if (payload.id) {
    state.fbid = payload.id;
    localStorage.setItem('fbid', payload.id);
  }
  if (payload.googleProfileImage) {
    state.googleProfileImage = payload.googleProfileImage;
    localStorage.setItem('googleProfileImage', payload.googleProfileImage);
  }
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.UPDATEVERIFIED, function (state, payload) {
  state.isVerified = payload.isVerified;
  localStorage.setItem('is_verified', payload.isVerified);
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.UPDATEFAV, function (state, payload) {
  state.favHomeProject = payload;
  localStorage.setItem('fav_home_project', (0, _stringify2.default)(state.favHomeProject));
}), (0, _defineProperty3.default)(_CHECK$LOGIN$LOGOUT$U, _mutationTypes.SETUSERINFO, function (state, payload) {
  state.isVerified = payload.is_phone_verified;
  state.isBroker = payload.is_broker;
  state.phone = payload.phone;
  state.countryCode = payload.ph_country_code;
  state.favHomeProject = payload.favourite_projects;
  localStorage.setItem('fav_home_project', (0, _stringify2.default)(payload.favourite_projects));
  localStorage.setItem('is_broker', payload.is_broker);
  localStorage.setItem('is_verified', payload.is_phone_verified);
  localStorage.setItem('country_code', payload.ph_country_code);
  localStorage.setItem('phone', payload.phone);
  if (payload.name) {
    state.name = payload.name;
    localStorage.setItem('name', payload.name);
  }
  if (payload.dev_id) localStorage.setItem('dev_id', payload.dev_id);
}), _CHECK$LOGIN$LOGOUT$U);

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  authenticated: false,
  isBroker: false,
  isInternal: false,
  brokerCustomersData: [],
  permissions: [],
  name: null,
  phone: null,
  bdUploadedProjects: null,
  fbid: null,
  googleProfileImage: null,
  isVerified: false,
  countryCode: '',
  favHomeProject: []
};

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(194);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  getFavProjects: function getFavProjects(_ref) {
    var commit = _ref.commit;

    _commonApi2.default.get(_endpoint.GETBROKERFAVOURITES).then(function (response) {
      commit(types.FAVOURITES, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyCustomers: function getMyCustomers(_ref2) {
    var commit = _ref2.commit;

    _commonApi2.default.get(_endpoint.BROKERCUSTOMERS).then(function (response) {
      commit(types.MYCUSTOMERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyProjects: function getMyProjects(_ref3, payload) {
    var commit = _ref3.commit;

    _commonApi2.default.get(_endpoint.BROKERPROJECTS).then(function (response) {
      commit(types.MYPROJECTS, response);
      if (payload && payload.cb_success) payload.cb_success(response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getLiveProjects: function getLiveProjects(_ref4, payload) {
    var commit = _ref4.commit;

    _commonApi2.default.get(_endpoint.LIVEPROJECTS).then(function (response) {
      commit(types.LIVEPROJECTS, response);
      if (payload && payload.cb_success) payload.cb_success(response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyFavourites: function getMyFavourites(_ref5) {
    var commit = _ref5.commit;

    _commonApi2.default.get(_endpoint.BROKERFAVOURITES).then(function (response) {
      commit(types.MYFAVOURITES, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  setCustomerAccessToken: function setCustomerAccessToken(_ref6, token) {
    var commit = _ref6.commit;

    commit(types.CUSTOMERTOKEN, token);
  },
  removeCustomerAccessToken: function removeCustomerAccessToken(_ref7) {
    var commit = _ref7.commit;

    commit(types.CUSTOMERTOKEN, '');
  },
  addCustomer: function addCustomer(_ref8, payload) {
    var _commit = _ref8._commit;

    _commonApi2.default.post(_endpoint.BROKERACCOUNT, payload.user).then(function (response) {
      payload.cb(response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  editCustomer: function editCustomer(_ref9, payload) {
    var _commit = _ref9._commit;

    _commonApi2.default.put(_endpoint.BROKERACCOUNT, payload.user).then(function (response) {
      payload.cb(response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  removeCustomer: function removeCustomer(_ref10, payload) {
    var _commit = _ref10._commit;

    _commonApi2.default.delete(_endpoint.BROKERACCOUNT, payload.customerID).then(function () {
      payload.cb();
    }).catch(function (error) {
      console.log(error);
    });
  },
  getBuilders: function getBuilders(_ref11) {
    var commit = _ref11.commit;

    _commonApi2.default.get(_endpoint.GETBUILDERS).then(function (response) {
      commit(types.BUILDERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  addBrokerCustomer: function addBrokerCustomer(_ref12, payload) {
    var _commit = _ref12._commit;

    _commonApi2.default.post(_endpoint.BROKERADDCUSTOMERS, payload.data).then(function (response) {
      if (payload.cb_success) payload.cb_success(response);
    }).catch(function (error) {
      if (payload.cb_error) payload.cb_error(error);
    });
  },
  getAddedCustomers: function getAddedCustomers(_ref13, payload) {
    var commit = _ref13.commit;

    _commonApi2.default.get(_endpoint.BROKERADDEDCUSTOMERS).then(function (response) {
      commit(types.MYADDEDCUSTOMERS, response);
      if (payload && payload.cb_success) payload.cb_success();
    }).catch(function (error) {
      console.log(error);
      if (payload.cb_error) payload.cb_error(error);
    });
  },
  editAddedCustomer: function editAddedCustomer(_ref14, payload) {
    var dispatch = _ref14.dispatch;

    _commonApi2.default.put(_endpoint.BROKEREDITCUSTOMERS, payload).then(function () {
      dispatch('getAddedCustomers');
      if (payload.cb_success) payload.cb_success();
    }).catch(function (error) {
      if (payload.cb_error) payload.cb_error(error);
      console.log(error);
    });
  },
  placeCustomerBid: function placeCustomerBid(_ref15, payload) {
    var _commit = _ref15._commit;

    _commonApi2.default.post(_endpoint.BROKERCUSTOMERBID, payload.data).then(function () {
      if (payload.cb_success) payload.cb_success();
    }).catch(function (error) {
      if (payload.cb_error) payload.cb_error(error);
    });
  },
  addSiteVisit: function addSiteVisit(_ref16, payload) {
    var _commit = _ref16._commit;

    _commonApi2.default.post(_endpoint.BROKERSITEVISIT, payload.data).then(function (response) {
      payload.cb_success(response);
    }).catch(function (error) {
      payload.cb_error(error);
      console.log(error);
    });
  },
  editSiteVisit: function editSiteVisit(_ref17, payload) {
    var _commit = _ref17._commit;

    _commonApi2.default.put('' + _endpoint.BROKERSITEVISIT + payload.data.id + '/', payload.data).then(function () {
      payload.cb_success();
    }).catch(function (error) {
      payload.cb_error(error);
      console.log(error);
    });
  },
  resetToDefaultState: function resetToDefaultState(_ref18) {
    var commit = _ref18.commit;

    commit(types.RESET);
  }
};

exports.default = actions;

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(457);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(458);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(460);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(461);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _FAVOURITES$CUSTOMERT;

var _mutationTypes = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_FAVOURITES$CUSTOMERT = {}, (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.FAVOURITES, function (state, payload) {
  state.favourites = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.CUSTOMERTOKEN, function (state, payload) {
  state.customerAccessToken = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.MYPROJECTS, function (state, payload) {
  state.myProjects = payload.projects ? payload.projects : payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.LIVEPROJECTS, function (state, payload) {
  state.liveProjects = payload.projects ? payload.projects : payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.MYFAVOURITES, function (state, payload) {
  state.myFavourites = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.MYCUSTOMERS, function (state, payload) {
  state.myCustomers = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.MYADDEDCUSTOMERS, function (state, payload) {
  state.myAddedCustomers = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.EDITADDEDCUSTOMERS, function (state, payload) {
  state.myAddedCustomers = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.BUILDERS, function (state, payload) {
  state.builders = payload;
}), (0, _defineProperty3.default)(_FAVOURITES$CUSTOMERT, _mutationTypes.RESET, function (state) {
  state.favourites = [];
  state.customerAccessToken = '';
  state.myFavourites = [];
  state.myProjects = [];
  state.liveProjects = [];
  state.myCustomers = {};
}), _FAVOURITES$CUSTOMERT);

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  favourites: [],
  customerAccessToken: '',
  myFavourites: [],
  myProjects: [],
  myCustomers: {},
  myAddedCustomers: {},
  builders: []
};

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(195);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _vueRouter = __webpack_require__(90);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var home = function home(_ref, payload) {
  var commit = _ref.commit;

  var apiUrl = _endpoint.HOME;
  var city = _store2.default.state.home.city;
  if (city && city !== 'All City') apiUrl = _endpoint.HOME + '?city=' + city;
  if (payload && payload.city !== 'All City') apiUrl = _endpoint.HOME + '?city=' + payload.city;
  _commonApi2.default.get(apiUrl).then(function (response) {
    commit(types.HOME, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var favProjects = function favProjects(_ref2) {
  var commit = _ref2.commit;

  _commonApi2.default.get(_endpoint.PROJECTFAVOURITE).then(function (response) {
    commit(types.FAVPROJECTS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var addFavProjects = function addFavProjects(_ref3, payload) {
  var commit = _ref3.commit;

  _commonApi2.default.post(_endpoint.PROJECTFAVOURITE, payload.data).then(function (response) {
    var dataToAdd = void 0;
    if (payload.data.type === 'unit') {
      dataToAdd = {
        project_id: payload.project_id,
        unit_id: payload.data.id,
        fav_id: response.fav_id
      };
    } else {
      dataToAdd = {
        project_id: payload.data.id,
        fav_id: response.fav_id
      };
    }
    commit(types.ADDFAVPROJECTS, dataToAdd);
    if (payload.cb_success) payload.cb_success(dataToAdd);
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

var setOverlayActive = function setOverlayActive(_ref4, payload) {
  var commit = _ref4.commit;

  commit(types.SETOVERLAYSTATE, payload);
};

var getLocalities = function getLocalities(_ref5) {
  var commit = _ref5.commit;

  _commonApi2.default.get(_endpoint.GETLOCALITIES).then(function (response) {
    commit(types.LOCALITIES, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var getTags = function getTags(_ref6) {
  var commit = _ref6.commit;

  _commonApi2.default.get(_endpoint.GETTAGS).then(function (response) {
    commit(types.TAGS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var deleteFavProjects = function deleteFavProjects(_ref7, payload) {
  var commit = _ref7.commit;

  _commonApi2.default.deleteWithParams(_endpoint.PROJECTFAVOURITE, payload.data).then(function () {
    commit(types.DELETEFAVPROJECTS, { fav_id: payload.data.id, isUnit: payload.isUnit });
    if (payload.cb_success) payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

var getProjectDetails = function getProjectDetails(_ref8, payload) {
  var commit = _ref8.commit;

  var details = _store2.default.state.home.projectDetails;
  if (payload.data.forceGet || !details || details.project_id !== payload.data.id) {
    _commonApi2.default.get('' + _endpoint.PROJECTDETAILS + payload.data.id + '/').then(function (response) {
      response.project_id = payload.data.id;
      commit(types.PROJECTDETAILS, response);
    }).catch(function (error) {
      payload.cb_error(error);
    });
  }
};

var getUnitDetails = function getUnitDetails(_ref9, payload) {
  var commit = _ref9.commit;

  var apiUrl = _endpoint.UNITDETAILS.replace('id', payload.id);
  _commonApi2.default.get(apiUrl).then(function (response) {
    response.project_id = payload.id;
    commit(types.SETUNITDETAILS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var getSiteDRM = function getSiteDRM(_ref10, payload) {
  var commit = _ref10.commit;

  _commonApi2.default.get(_endpoint.SITEVISIT + '?project_id=' + payload.id).then(function (response) {
    commit(types.SITEDRM, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var addSiteVisit = function addSiteVisit(_ref11, payload) {
  var _commit = _ref11._commit;

  _commonApi2.default.post(_endpoint.SITEVISIT, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

var editSiteVisit = function editSiteVisit(_ref12, payload) {
  var _commit = _ref12._commit;

  _commonApi2.default.put('' + _endpoint.SITEVISIT + payload.data.id + '/', payload.data).then(function () {
    payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

var deleteSiteVisit = function deleteSiteVisit(_ref13, payload) {
  var _commit = _ref13._commit;

  _commonApi2.default.delete('' + _endpoint.SITEVISIT + payload.data.id + '/', payload.data).then(function () {
    payload.cb_success();
  }).catch(function (error) {
    payload.cb_error();
    console.log(error);
  });
};

var placeBid = function placeBid(_ref14, payload) {
  var _commit = _ref14._commit;

  _commonApi2.default.post(_endpoint.BID, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    payload.cb_error(error);
  });
};

var reviseBid = function reviseBid(_ref15, payload) {
  var _commit = _ref15._commit;

  _commonApi2.default.put(_endpoint.BID, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    payload.cb_error(error);
  });
};

var updateBid = function updateBid(_ref16, payload) {
  var commit = _ref16.commit;

  commit(types.UPDATEBID, payload);
};

var book = function book(_ref17, payload) {
  var _commit = _ref17._commit;

  _commonApi2.default.post(_endpoint.BOOK, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

var getNotifications = function getNotifications(_ref18) {
  var commit = _ref18.commit,
      _state = _ref18._state;

  _commonApi2.default.get(_endpoint.GETNOTIFICATIONS).then(function (response) {
    commit(types.GETNOTIFICATIONS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var addNotifications = function addNotifications(_ref19, payload) {
  var commit = _ref19.commit;

  commit(types.ADDNOTIFICATIONS, payload);
};

var updateNotifications = function updateNotifications(_ref20, payload) {
  var commit = _ref20.commit,
      _state = _ref20._state;

  _commonApi2.default.put(_endpoint.EDITNOTIFICATIONS, payload.data).then(function () {
    commit(types.UPDATENOTIFICATIONS, payload);
    payload.cb_success();
  }).catch(function (error) {
    console.log(error);
  });
};

var getPaymentDetails = function getPaymentDetails(_ref21, payload) {
  var _commit = _ref21._commit;

  _commonApi2.default.post(_endpoint.PAYMENTDETAILS, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    console.log(error);
    payload.cb_error(error);
  });
};

var cancelBooking = function cancelBooking(_ref22, payload) {
  var _commit = _ref22._commit;

  _commonApi2.default.post(_endpoint.CANCELBOOKING, payload.data).then(function (response) {
    payload.cb_success(response);
  }).catch(function (error) {
    console.log(error);
  });
};

var getBidStrength = function getBidStrength(_ref23, payload) {
  var commit = _ref23.commit;

  _commonApi2.default.post(_endpoint.GETBIDSTRENGTH, payload).then(function (response) {
    var bidStrength = {
      strength: response
    };
    commit(types.GETBIDSTRENGTH, bidStrength);
  }).catch(function (error) {
    console.log(error);
  });
};

var getFooterProjects = function getFooterProjects(_ref24) {
  var commit = _ref24.commit,
      state = _ref24.state;

  if (!state.footerProjects) {
    _commonApi2.default.get(_endpoint.FOOTERPROJECTS).then(function (response) {
      commit(types.FOOTERPROJECTS, response);
    }).catch(function (error) {
      console.log(error);
    });
  }
};

var resetToDefaultState = function resetToDefaultState(_ref25) {
  var commit = _ref25.commit;

  commit(types.RESET);
};

var showWonLostBid = function showWonLostBid(_ref26, payload) {
  var commit = _ref26.commit;

  commit(types.SHOWWONLOSTBID, payload);
  if (payload.bid.status === 'Lost') localStorage.setItem(payload.bid.project_id + '_bid_lost', true);
};

var setCity = function setCity(_ref27, payload) {
  var commit = _ref27.commit;

  commit(types.SETCITY, payload);
};

var compareProject = function compareProject(_ref28, payload) {
  var commit = _ref28.commit;

  var data = payload.join();
  _commonApi2.default.get(_endpoint.GETCOMPAREPROJECT + '?projects=' + data).then(function (response) {
    commit(types.SETCOMPAREDATA, response);
  }).catch(function (error) {
    console.log(error);
  });
};
var getProjectList = function getProjectList(_ref29) {
  var commit = _ref29.commit;

  _commonApi2.default.get(_endpoint.GETPROJECTLIST).then(function (response) {
    commit(types.SETPROJECTLIST, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var updateFavUnit = function updateFavUnit(_ref30, payload) {
  var commit = _ref30.commit;

  _commonApi2.default.post(_endpoint.PROJECTFAVOURITE, payload.data).then(function (response) {
    var dataToAdd = {
      display_text: payload.unit_name,
      unit_id: payload.data.id,
      fav_id: response.fav_id
    };
    commit(types.ADDFAVUNITS, dataToAdd);
    if (payload.cb_success) payload.cb_success(dataToAdd);
  }).catch(function (error) {
    payload.cb_error(error);
  });
};

var deleteFavUnit = function deleteFavUnit(_ref31, payload) {
  var commit = _ref31.commit;

  _commonApi2.default.deleteWithParams(_endpoint.PROJECTFAVOURITE, payload.data).then(function () {
    commit(types.DELETEFAVUNITS, { fav_id: payload.data.id });
    if (payload.cb_success) payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
  });
};

var getListingPageData = function getListingPageData(_ref32, payload) {
  var commit = _ref32.commit;

  _commonApi2.default.get(_endpoint.SEARCHDETAILS, payload.query, true).then(function (response) {
    commit(types.GETLISTINGDATA, response);
    if (payload.cb_success) payload.cb_success(response);
  }).catch(function (error) {
    console.log(error);
  });
};

var updateListingProjects = function updateListingProjects(_ref33, payload) {
  var commit = _ref33.commit;

  commit(types.GETLISTINGDATA, payload);
};

var getExculsiveProjects = function getExculsiveProjects(_ref34, payload) {
  var commit = _ref34.commit;

  _commonApi2.default.get(_endpoint.GETEXCLUSIVEPROJECTS, payload.query, true).then(function (response) {
    commit(types.GETLISTINGDATA, response);
    if (payload.cb_success) payload.cb_success(response);
  }).catch(function (error) {
    console.log(error);
  });
};

var updateProject = function updateProject(_ref35, payload) {
  var commit = _ref35.commit;

  commit(types.UPDATEPROJECT, payload);
  if (payload.project.auction_status === 'CLOSED' && _vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project.id && !localStorage.getItem(payload.project.id + '_bid_lost')) commit(types.SHOWAUCTIONLOST, payload);
};

var getStats = function getStats(_ref36) {
  var commit = _ref36.commit;

  _commonApi2.default.get(_endpoint.STATISTICS).then(function (response) {
    commit(types.UPDATESTATS, response);
  }).catch(function (error) {
    console.log(error);
  });
};

var updateStats = function updateStats(_ref37, payload) {
  var commit = _ref37.commit;

  commit(types.UPDATESTATS, payload);
};

var updateUnit = function updateUnit(_ref38, payload) {
  var commit = _ref38.commit;

  commit(types.UPDATEUNITS, payload);
};

var updateLocality = function updateLocality(_ref39, payload) {
  var commit = _ref39.commit;

  commit(types.FOOTERPROJECTS, payload);
};

var updateFavUnitSignal = function updateFavUnitSignal(_ref40, payload) {
  var commit = _ref40.commit;

  commit(types.UPDATEFAVUNITSIGNAL, payload);
};
var removeSoldUnit = function removeSoldUnit(_ref41, payload) {
  var commit = _ref41.commit;

  commit(types.REMOVESOLDUNIT, payload);
};

var withdrawUserBid = function withdrawUserBid(_ref42, payload) {
  var _commit = _ref42._commit;

  var apiUrl = _endpoint.WITHDRAWBID.replace('bid-id', payload.id);
  _commonApi2.default.put(apiUrl).then(function () {
    payload.cb_success();
  }).catch(function (error) {
    payload.cb_error(error);
    console.log(error);
  });
};

exports.default = {
  home: home,
  favProjects: favProjects,
  addFavProjects: addFavProjects,
  deleteFavProjects: deleteFavProjects,
  getProjectDetails: getProjectDetails,
  addSiteVisit: addSiteVisit,
  deleteSiteVisit: deleteSiteVisit,
  editSiteVisit: editSiteVisit,
  placeBid: placeBid,
  reviseBid: reviseBid,
  getNotifications: getNotifications,
  addNotifications: addNotifications,
  updateNotifications: updateNotifications,
  getPaymentDetails: getPaymentDetails,
  book: book,
  updateBid: updateBid,
  cancelBooking: cancelBooking,
  getBidStrength: getBidStrength,
  getFooterProjects: getFooterProjects,
  getLocalities: getLocalities,
  getTags: getTags,
  setOverlayActive: setOverlayActive,
  resetToDefaultState: resetToDefaultState,
  showWonLostBid: showWonLostBid,
  getSiteDRM: getSiteDRM,
  setCity: setCity,
  compareProject: compareProject,
  getProjectList: getProjectList,
  getUnitDetails: getUnitDetails,
  updateFavUnit: updateFavUnit,
  deleteFavUnit: deleteFavUnit,
  getListingPageData: getListingPageData,
  updateListingProjects: updateListingProjects,
  getExculsiveProjects: getExculsiveProjects,
  updateProject: updateProject,
  updateStats: updateStats,
  getStats: getStats,
  updateUnit: updateUnit,
  updateLocality: updateLocality,
  updateFavUnitSignal: updateFavUnitSignal,
  removeSoldUnit: removeSoldUnit,
  withdrawUserBid: withdrawUserBid
};

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(462);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(463);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(465);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(466);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(114);

var _keys2 = _interopRequireDefault(_keys);

var _RESET$HOME$SETOVERLA;

var _hub = __webpack_require__(113);

var _hub2 = _interopRequireDefault(_hub);

var _lodash = __webpack_require__(175);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueRouter = __webpack_require__(90);

var _mutationTypes = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_RESET$HOME$SETOVERLA = {}, (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.RESET, function (state) {
  state.favProjects = null;
  state.favUnits = null;
  state.projectDetails = null;
  state.notifications = null;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.HOME, function (state, payload) {
  state.homeProjects = payload.projects;
  state.homeDevelopers = payload.developers;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SETOVERLAYSTATE, function (state, payload) {
  state.overlayState = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.FAVPROJECTS, function (state, payload) {
  state.favProjects = payload.fav_projects;
  state.favUnits = payload.fav_units;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.ADDFAVPROJECTS, function (state, payload) {
  if (payload.unit_id) {
    state.favUnits.push({
      project_id: payload.project_id,
      fav_id: payload.fav_id,
      unit_id: payload.unit_id
    });
  } else {
    state.favProjects.push({
      project_id: payload.project_id,
      fav_data: {
        isFav: true,
        fav_id: payload.fav_id,
        units: []
      }
    });
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.DELETEFAVPROJECTS, function (state, payload) {
  if (payload.isUnit) state.favUnits = state.favUnits.filter(function (m) {
    return '' + m.fav_id !== '' + payload.fav_id;
  });else state.favProjects = state.favProjects.filter(function (m) {
    return '' + m.fav_data.fav_id !== '' + payload.fav_id;
  });
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.PROJECTDETAILS, function (state, payload) {
  state.projectDetails = payload;
  state.projectFavUnit = payload.favourite;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.GETNOTIFICATIONS, function (state, payload) {
  state.notifications = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.ADDNOTIFICATIONS, function (state, payload) {
  if (payload) {
    payload.is_read = false;
    if (state.notifications) state.notifications.unshift(payload);else state.notifications = [payload];
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATENOTIFICATIONS, function (state) {
  if (state.notifications) {
    state.notifications.forEach(function (m) {
      m.is_read = true;
    });
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.FOOTERPROJECTS, function (state, payload) {
  state.footerProjects = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.LOCALITIES, function (state, payload) {
  state.localities = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.TAGS, function (state, payload) {
  state.tags = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SITEDRM, function (state, payload) {
  state.siteDrm = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.GETBIDSTRENGTH, function (state, payload) {
  state.bidStrength = payload.strength;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SHOWWONLOSTBID, function (_state, payload) {
  _hub2.default.$emit('open-modal');
  _hub2.default.$emit('set-modal-data', payload, 'won-lost-bid');
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SHOWAUCTIONLOST, function (_state, data) {
  _hub2.default.$emit('open-modal');
  _hub2.default.$emit('set-modal-data', data, 'auction-end');
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SETCITY, function (state, payload) {
  state.city = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SETCOMPAREDATA, function (state, payload) {
  var data = {};
  payload.forEach(function (item) {
    data[item.id] = item;
  });
  state.compareData = data;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SETPROJECTLIST, function (state, payload) {
  state.projectList = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.SETUNITDETAILS, function (state, payload) {
  state.unitDetails = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.ADDFAVUNITS, function (state, payload) {
  state.projectFavUnit.push(payload);
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.DELETEFAVUNITS, function (state, payload) {
  state.projectFavUnit = state.projectFavUnit.filter(function (m) {
    return '' + m.fav_id !== '' + payload.fav_id;
  });
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.GETLISTINGDATA, function (state, payload) {
  if (payload.project_details) state.listData = payload.project_details;else state.listData = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATEPROJECT, function (state, payload) {
  if (payload) {
    var path = window.location.href;
    if (_vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project.id) {
      var pd = state.projectDetails;
      var keys = (0, _keys2.default)(payload);
      keys.forEach(function (m) {
        pd[m] = payload[m];
      });
      state.projectDetails = pd;
    } else if (path.includes('/') && !payload.demo) {
      state.homeProjects.forEach(function (m, index) {
        if (m.id === payload.project.id) {
          state.homeProjects.splice(index, 1);
          if (payload.project.auction_status !== 'CLOSED') state.homeProjects.push(payload.project);
        }
      });
      var matchedObj = _lodash2.default.find(state.homeProjects, function (m) {
        return m.id === payload.project.id;
      });
      if (!matchedObj && payload.project.auction_status !== 'CLOSED') state.homeProjects.push(payload.project);
    }
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATESTATS, function (state, payload) {
  state.stats = payload;
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATEUNITS, function (state, payload) {
  if (payload) {
    if (_vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project_id) {
      state.unitDetails = payload.unit_data;
      console.log('Mutation UPDATEUNITS executed', {
        payload: payload,
        state: state
      });
    }
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATEBID, function (state, payload) {
  if (_vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project_id) {
    if (state.projectDetails && state.projectDetails.bid) {
      state.projectDetails.bid.bid_amount = payload.bid_amount;
      state.projectDetails.bid = payload;
    }
  }
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.UPDATEFAVUNITSIGNAL, function (state, payload) {
  if (_vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project_id) state.projectFavUnit = [];
}), (0, _defineProperty3.default)(_RESET$HOME$SETOVERLA, _mutationTypes.REMOVESOLDUNIT, function (state, payload) {
  if (_vueRouter.router.currentRoute.name === 'home.projectdetails' && parseInt(_vueRouter.router.currentRoute.query.id, 10) === payload.project_id && state.projectFavUnit && state.projectFavUnit.length) state.projectFavUnit = state.projectFavUnit.filter(function (m) {
    return m.unit_id !== payload.unit_id;
  });
}), _RESET$HOME$SETOVERLA);

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  homeDevelopers: null,
  homeProjects: null,
  favProjects: null,
  favUnits: null,
  projectDetails: null,
  notifications: null,
  footerProjects: null,
  bidStrength: '',
  localities: null,
  tags: null,
  overlayState: false,
  siteDrm: {},
  city: '',
  compareData: null,
  projectList: null,
  unitDetails: null,
  projectFavUnit: null,
  listData: null,
  stats: null
};

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(196);

var types = _interopRequireWildcard(_mutationTypes);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {

  updateProjectMaster: function updateProjectMaster(_ref, payload) {
    var commit = _ref.commit;

    commit(types.MASTER, payload);
    commit(types.CALCULATESOLDUNITS);
  },

  updateProject: function updateProject(_ref2, payload) {
    var commit = _ref2.commit;

    var url = window.location.href;
    if (url.includes('/edit-inventory/')) {
      var projectId = url.substr(url.indexOf('/edit-inventory/') + '/edit-inventory/'.length, url.length);
      if ('' + projectId === '' + payload.id) _store2.default.dispatch('auctioneer/getInventoryDetails', payload.id);
    }
    commit(types.UPDATEPROJECT, payload);
  },

  addProject: function addProject(_ref3, payload) {
    var commit = _ref3.commit;

    commit(types.ADDPROJECT, payload);
  },

  setLoaderState: function setLoaderState(_ref4, payload) {
    var commit = _ref4.commit;

    commit(types.SETLOADER, payload);
  },

  updateInternalMaster: function updateInternalMaster(_ref5, payload) {
    var commit = _ref5.commit;

    commit(types.INTERNALMASTER, payload);
    commit(types.CALCULATESOLDUNITS);
  }
};

exports.default = actions;

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(114);

var _keys2 = _interopRequireDefault(_keys);

var _storageApi = __webpack_require__(190);

var _storageApi2 = _interopRequireDefault(_storageApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getProjectMaster: function getProjectMaster(state) {
    return state.projectMaster || _storageApi2.default.getSessionData('pm');
  },
  getAuctions: function getAuctions(state) {
    var master = state.projectMaster;
    var auctions = {};
    if (master) {
      var ids = (0, _keys2.default)(master).filter(function (id) {
        return master[id].auction_status === 'LIVE-AUCTION' || master[id].auction_status === 'UPCOMING-AUCTION';
      });
      ids.forEach(function (id) {
        auctions[id] = master[id];
      });
    }
    return auctions;
  },
  getScheduled: function getScheduled(state) {
    var master = state.projectMaster;
    var scheduled = {};
    if (master) {
      var ids = (0, _keys2.default)(master).filter(function (id) {
        return master[id].auction_status === 'VALUE-LISTING' || master[id].auction_status === 'NEW' || master[id].auction_status === 'CLOSED';
      });
      ids.forEach(function (id) {
        scheduled[id] = master[id];
      });
    }
    return scheduled;
  },
  getVerified: function getVerified(state) {
    var master = state.projectMaster;
    var verified = {};
    if (master) {
      var ids = (0, _keys2.default)(master).filter(function (id) {
        return master[id].auction_status !== 'NOT-VERIFIED';
      });
      ids.forEach(function (id) {
        verified[id] = master[id];
      });
    }
    return verified;
  }
};

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(467);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(468);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(470);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(471);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(114);

var _keys2 = _interopRequireDefault(_keys);

var _MASTER$CALCULATESOLD;

var _mutationTypes = __webpack_require__(196);

var _storageApi = __webpack_require__(190);

var _storageApi2 = _interopRequireDefault(_storageApi);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _lodash = __webpack_require__(175);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_MASTER$CALCULATESOLD = {}, (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.MASTER, function (state, payload) {
  if (payload.pm) {
    state.projectMaster = payload.pm;
    _storageApi2.default.setSessionData('pm', payload.pm);
  } else {
    state.projectMaster = payload;
    _storageApi2.default.setSessionData('pm', payload);
  }
}), (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.CALCULATESOLDUNITS, function (state) {
  (0, _keys2.default)(state.projectMaster).forEach(function (key) {
    var project = state.projectMaster[key];
    var unitDetails = project.unit_details;
    var unitMap = unitDetails.unit_type_map;

    unitDetails.sold_units = { TOTAL: 0 };
    unitDetails.total_units = { TOTAL: 0 };
    var soldUnits = unitDetails.sold_units;
    var totalUnits = unitDetails.total_units;

    (0, _keys2.default)(unitMap).forEach(function (unitMapKey) {
      soldUnits[unitMapKey] = unitMap[unitMapKey].filter(function (unit) {
        return unit.sold;
      }).length;
      soldUnits.TOTAL += soldUnits[unitMapKey];
      totalUnits[unitMapKey] = unitMap[unitMapKey].length;
      totalUnits.TOTAL += totalUnits[unitMapKey];
    });
  });
}), (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.UPDATEPROJECT, function (state, payload) {
  if (state.projectMaster) {
    var project = payload;
    var previousProjectStatus = '';
    if (state.projectMaster[project.id]) previousProjectStatus = state.projectMaster[project.id].auction_status;
    if (previousProjectStatus !== project.auction_status) _store2.default.dispatch('home/home');
    var unitDetails = project.unit_details;
    var unitMap = unitDetails.unit_type_map;
    if (unitDetails && unitMap) {
      unitDetails.sold_units = { TOTAL: 0 };
      unitDetails.total_units = { TOTAL: 0 };
      var soldUnits = unitDetails.sold_units;
      var totalUnits = unitDetails.total_units;
      (0, _keys2.default)(unitMap).forEach(function (unitMapKey) {
        soldUnits[unitMapKey] = unitMap[unitMapKey].filter(function (unit) {
          return unit.sold;
        }).length;
        soldUnits.TOTAL += soldUnits[unitMapKey];
        totalUnits[unitMapKey] = unitMap[unitMapKey].length;
        totalUnits.TOTAL += totalUnits[unitMapKey];
      });
    }
    state.projectMaster[project.id] = project;
  }
}), (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.ADDPROJECT, function (state, payload) {
  var pm = _lodash2.default.cloneDeep(state.projectMaster);
  if (pm) {
    var project = payload;
    var unitDetails = project.unit_details;
    var unitMap = unitDetails.unit_type_map;
    if (unitDetails && unitMap) {
      unitDetails.sold_units = { TOTAL: 0 };
      unitDetails.total_units = { TOTAL: 0 };
      var soldUnits = unitDetails.sold_units;
      var totalUnits = unitDetails.total_units;
      (0, _keys2.default)(unitMap).forEach(function (unitMapKey) {
        soldUnits[unitMapKey] = unitMap[unitMapKey].filter(function (unit) {
          return unit.sold;
        }).length;
        soldUnits.TOTAL += soldUnits[unitMapKey];
        totalUnits[unitMapKey] = unitMap[unitMapKey].length;
        totalUnits.TOTAL += totalUnits[unitMapKey];
      });
    }
    pm[project.id] = project;
  }
  state.projectMaster = _lodash2.default.cloneDeep(pm);
}), (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.SETLOADER, function (state, payload) {
  state.loader = payload;
}), (0, _defineProperty3.default)(_MASTER$CALCULATESOLD, _mutationTypes.INTERNALMASTER, function (state, payload) {
  state.projectMaster[payload.id] = payload;
  _storageApi2.default.setSessionData('pm', state.projectMaster);
}), _MASTER$CALCULATESOLD);

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  projectMaster: null,
  loader: false
};

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(197);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  getRmLiveDetails: function getRmLiveDetails(_ref, auctionId) {
    var commit = _ref.commit;

    _commonApi2.default.get('' + _endpoint.RMLIVE + auctionId + '/').then(function (response) {
      commit(types.RMLIVEDETAILS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyCustomers: function getMyCustomers(_ref2) {
    var commit = _ref2.commit;

    _commonApi2.default.get(_endpoint.RMCUSTOMERS).then(function (response) {
      commit(types.MYCUSTOMERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyBrokers: function getMyBrokers(_ref3) {
    var commit = _ref3.commit;

    _commonApi2.default.get(_endpoint.RMBROKERS).then(function (response) {
      commit(types.MYBROKERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyProjects: function getMyProjects(_ref4) {
    var commit = _ref4.commit;

    _commonApi2.default.get(_endpoint.RMPROJECTS).then(function (response) {
      commit(types.MYPROJECTS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getDrmBrokers: function getDrmBrokers(_ref5) {
    var commit = _ref5.commit;

    _commonApi2.default.get(_endpoint.DRMBROKERS).then(function (response) {
      commit(types.DRMBROKERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getRM: function getRM(_ref6, payload) {
    var commit = _ref6.commit;

    _commonApi2.default.get('' + _endpoint.GETRM + payload.id + '/').then(function (response) {
      console.log('RMs ->', response);
      commit(types.GETRM, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  sendPaymentLink: function sendPaymentLink(_ref7, payload) {
    var commit = _ref7.commit;

    _commonApi2.default.post(_endpoint.SENDPAYMENTLINK, payload).then(function (response) {
      console.log('Payment link response ->', response, commit);
    }).catch(function (error) {
      console.log(error);
    });
  },
  releaseUnit: function releaseUnit(_ref8, payload) {
    var commit = _ref8.commit;

    _commonApi2.default.post('' + _endpoint.RELEASEUNIT + payload.bidId + '/').then(function (response) {
      console.log('RMs ->', response, commit);
      if (payload && payload.cbSuccess) payload.cbSuccess(response);
    }).catch(function (error) {
      console.log(error);
      if (payload && payload.cbSuccess) payload.cbError(error.message || error.detail);
    });
  },
  updateRmLive: function updateRmLive(_ref9, payload) {
    var commit = _ref9.commit;

    commit(types.UPDATERMLIVEDETAILS, payload);
  },
  updateRmBroker: function updateRmBroker(_ref10, payload) {
    var commit = _ref10.commit;

    commit(types.UPDATERMBROKER, payload);
  },
  updateRmCustomer: function updateRmCustomer(_ref11, payload) {
    var commit = _ref11.commit;

    commit(types.UPDATERMCUSTOMER, payload);
  },
  updateRmProject: function updateRmProject(_ref12, payload) {
    var commit = _ref12.commit;

    commit(types.UPDATERMPROJECT, payload);
  }
};

exports.default = actions;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(472);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(473);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(475);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(476);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _MYCUSTOMERS$MYBROKER;

var _mutationTypes = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_MYCUSTOMERS$MYBROKER = {}, (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.MYCUSTOMERS, function (state, payload) {
  state.myCustomers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.MYBROKERS, function (state, payload) {
  state.myBrokers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.MYPROJECTS, function (state, payload) {
  state.myProjects = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.DRMBROKERS, function (state, payload) {
  state.drmBrokers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.GETRM, function (state, payload) {
  payload.forEach(function (element) {
    element.fullName = element.first_name + ' ' + element.last_name;
  });

  state.internalRMs = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.RMLIVEDETAILS, function (state, payload) {
  state.rmLive = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.UPDATERMLIVEDETAILS, function (state, payload) {
  if ('' + state.rmLive.auction_id === '' + payload.auction_id) state.rmLive = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.UPDATERMBROKER, function (state, payload) {
  state.myBrokers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.UPDATERMCUSTOMER, function (state, payload) {
  state.myCustomers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYBROKER, _mutationTypes.UPDATERMPROJECT, function (state, payload) {
  state.myProjects = payload;
}), _MYCUSTOMERS$MYBROKER);

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  myCustomers: {},
  myBrokers: {},
  myProjects: {},
  drmBrokers: {},
  internalRMs: [],
  rmLive: null
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(198);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  getMyCustomers: function getMyCustomers(_ref, payload) {
    var commit = _ref.commit;

    _commonApi2.default.get('' + _endpoint.SHCUSTOMERS + payload.id + '/').then(function (response) {
      commit(types.MYCUSTOMERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyProjects: function getMyProjects(_ref2, payload) {
    var commit = _ref2.commit;

    _commonApi2.default.get('' + _endpoint.SHPROJECTS + payload.id + '/').then(function (response) {
      commit(types.MYPROJECTS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getMyBrokers: function getMyBrokers(_ref3, payload) {
    var commit = _ref3.commit;

    _commonApi2.default.get('' + _endpoint.SHBROKERS + payload.id + '/').then(function (response) {
      commit(types.MYBROKERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getBrokersWithDrms: function getBrokersWithDrms(_ref4) {
    var commit = _ref4.commit;

    _commonApi2.default.get(_endpoint.BROKERLISTWITHDRM).then(function (response) {
      commit(types.BROKERLISTWITHDRM, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  editDrm: function editDrm(_ref5, payload) {
    var _commit = _ref5._commit;

    _commonApi2.default.post(_endpoint.EDITDRM, payload.data).then(function () {
      if (payload.cbSuccess) payload.cbSuccess();
    }).catch(function (error) {
      console.log(error);
      if (payload.cbError) payload.cbError();
    });
  },
  addRmToProject: function addRmToProject(_ref6, payload) {
    var _commit = _ref6._commit;

    _commonApi2.default.post('' + _endpoint.PROJECTRMDETAILS + payload.projectId + '/', { rm_id: payload.rmId }).then(function () {
      _store2.default.dispatch('users/getRmDetails', { id: payload.projectId });
      if (payload.cbSuccess) payload.cbSuccess();
    }).catch(function (error) {
      console.log(error);
      if (payload.cbError) payload.cbError();
    });
  },
  removeRmFromProject: function removeRmFromProject(_ref7, payload) {
    var _commit = _ref7._commit;

    _commonApi2.default.delete('' + _endpoint.PROJECTRMDETAILS + payload.projectId + '/', payload.rmId).then(function () {
      _store2.default.dispatch('users/getRmDetails', { id: payload.projectId });
    }).catch(function (error) {
      console.log(error);
      if (payload.cbError) payload.cbError(error);
    });
  },
  changeRMStatus: function changeRMStatus(_ref8, payload) {
    var _commit = _ref8._commit;

    _commonApi2.default.put(_endpoint.UPDATERMSTATUS, { id: payload.rmId }).then(function () {
      _store2.default.dispatch('users/getRmDetails', { id: payload.projectId });
    }).catch(function (error) {
      console.log(error);
      if (payload.cbError) payload.cbError(error);
    });
  }
};

exports.default = actions;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(477);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(478);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(480);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(481);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _MYCUSTOMERS$MYPROJEC;

var _mutationTypes = __webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_MYCUSTOMERS$MYPROJEC = {}, (0, _defineProperty3.default)(_MYCUSTOMERS$MYPROJEC, _mutationTypes.MYCUSTOMERS, function (state, payload) {
  state.myCustomers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYPROJEC, _mutationTypes.MYPROJECTS, function (state, payload) {
  state.myProjects = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYPROJEC, _mutationTypes.MYBROKERS, function (state, payload) {
  state.myBrokers = payload;
}), (0, _defineProperty3.default)(_MYCUSTOMERS$MYPROJEC, _mutationTypes.BROKERLISTWITHDRM, function (state, payload) {
  state.brokerListWithDrm = payload;
}), _MYCUSTOMERS$MYPROJEC);

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  myCustomers: {},
  myProjects: {},
  myBrokers: {},
  brokerListWithDrm: []
};

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(199);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var searchInitial = function searchInitial(_ref, payload) {
  var commit = _ref.commit;

  commit(types.INITIAL, payload);
};
var searchInitialDetails = function searchInitialDetails(_ref2, payload) {
  var commit = _ref2.commit;

  commit(types.INITIALDETAILS, payload);
};

var selectedSearch = function selectedSearch(_ref3, payload) {
  var commit = _ref3.commit;

  commit(types.SELECTEDSEARCH, payload);
};

exports.default = {
  searchInitial: searchInitial,
  searchInitialDetails: searchInitialDetails,
  selectedSearch: selectedSearch
};

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(482);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(483);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(485);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(486);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _INITIAL$INITIALDETAI;

var _mutationTypes = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_INITIAL$INITIALDETAI = {}, (0, _defineProperty3.default)(_INITIAL$INITIALDETAI, _mutationTypes.INITIAL, function (state, payload) {
  state.searchInitial = payload;
}), (0, _defineProperty3.default)(_INITIAL$INITIALDETAI, _mutationTypes.INITIALDETAILS, function (state, payload) {
  state.searchInitialDetails = payload;
}), (0, _defineProperty3.default)(_INITIAL$INITIALDETAI, _mutationTypes.SELECTEDSEARCH, function (state, payload) {
  state.selectedSearch = payload.selected;
  state.projectListQueryParams = payload.queryParams;
}), _INITIAL$INITIALDETAI);

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  searchInitial: {},
  searchInitialDetails: {},
  selectedSearch: [],
  projectListQueryParams: null
};

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(200);

var types = _interopRequireWildcard(_mutationTypes);

var _hub = __webpack_require__(113);

var _hub2 = _interopRequireDefault(_hub);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var wsocket = void 0;
var tm = [];
var interval = void 0;

var connect = function connect(_ref) {
  var dispatch = _ref.dispatch,
      commit = _ref.commit;

  var wsLocation = "https://backend.watabid.com".replace('https://', '');
  var url = 'wss://' + wsLocation + '/ws/';
  var token = localStorage.getItem('access_token');
  url = url + '?token=' + token;
  wsocket = new WebSocket(url);
  var payload = {
    socketId: 1,
    channel: wsocket
  };
  wsocket.onopen = function () {
    console.log('websocket open');
    commit(types.CONNECT, payload);

    interval = setInterval(function () {
      dispatch('ping');
    }, 30000);
  };

  wsocket.onmessage = function (evt) {
    var data = JSON.parse(evt.data);
    if (data.type === 'PONG') {
      console.log('inside onmsg before dispatching pong');
      dispatch('pong');
    } else dispatch('handleData', evt.data);
  };

  wsocket.onclose = function () {
    _hub2.default.$emit('socket-disconnected');
    commit(types.DISCONNECT);
  };
};

var sendData = function sendData(_ref2, payload) {
  var commit = _ref2.commit;

  console.log('Sending data...!', payload);
  commit(types.SENDDATA, payload);
};

var handleData = function handleData(_ref3, payload) {
  var commit = _ref3.commit;

  commit(types.HANDLEDATA, payload);
};

var disconnect = function disconnect(_ref4) {
  var commit = _ref4.commit;

  if (wsocket.readyState === WebSocket.OPEN) wsocket.close();
  commit(types.DISCONNECT);
};

var ping = function ping() {
  if (wsocket.readyState !== WebSocket.OPEN) {
    console.log('interval time', interval);
    clearInterval(interval);
    return;
  }
  console.log('inside ping wsocket state sending msg', wsocket.readyState);
  wsocket.send('{"type": "PING"}');
  tm.push(setTimeout(function () {
    console.log('dispatching disconnect');
    _store2.default.dispatch('socket/disconnect');
  }, 10000));
  console.log('tm on ping: ', tm);
};

var pong = function pong() {
  console.log('Inside pong. Clearing the timeout');
  tm.forEach(function (i) {
    return clearTimeout(i);
  });
  tm = [];
  console.log('tm on pong: ', tm);
};

exports.default = {
  connect: connect,
  sendData: sendData,
  handleData: handleData,
  disconnect: disconnect,
  ping: ping,
  pong: pong
};

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isConnected: function isConnected(state) {
    return state.isConnected;
  }
};

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(487);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(488);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(490);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(491);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _CONNECT$SENDDATA$HAN;

var _mutationTypes = __webpack_require__(200);

var _constants = __webpack_require__(392);

var _constants2 = _interopRequireDefault(_constants);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_CONNECT$SENDDATA$HAN = {}, (0, _defineProperty3.default)(_CONNECT$SENDDATA$HAN, _mutationTypes.CONNECT, function (state, payload) {
  state.socket.isConnected = true;
  state.socket.scoketId = payload.scoketId;
  state.socket.channel = payload.channel;
}), (0, _defineProperty3.default)(_CONNECT$SENDDATA$HAN, _mutationTypes.SENDDATA, function (state, payload) {
  state.socket.lastSentData = payload;
  state.socket.channel.send(payload.data);
}), (0, _defineProperty3.default)(_CONNECT$SENDDATA$HAN, _mutationTypes.HANDLEDATA, function (state, payload) {
  var data = JSON.parse(payload);
  console.log('Payload reveived from WebSocket', data);
  state.socket.lastHandledData = data;
  var action = _constants2.default.socketActionMapping[data.action];
  console.log('Action Dispatched: ', action);
  _store2.default.dispatch(action, data.data);
}), (0, _defineProperty3.default)(_CONNECT$SENDDATA$HAN, _mutationTypes.DISCONNECT, function (state) {
  state.socket.isConnected = false;
  state.socket.scoketId = null;
  state.socket.channel = null;
}), _CONNECT$SENDDATA$HAN);

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  socket: {
    channel: null,
    isConnected: false,
    scoketId: null,
    lastSentData: null,
    lastHandledData: null
  }
};

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mutationTypes = __webpack_require__(201);

var types = _interopRequireWildcard(_mutationTypes);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var actions = {
  getUsers: function getUsers(_ref) {
    var commit = _ref.commit;

    _commonApi2.default.get(_endpoint.USERS).then(function (response) {
      commit(types.USERS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  storeFormulaData: function storeFormulaData(_ref2, payload) {
    var commit = _ref2.commit;

    commit(types.STOREFORMULADATA, payload);
  },
  removeFormulaData: function removeFormulaData(_ref3) {
    var commit = _ref3.commit;

    commit(types.REMOVEFORMULADATA);
  },
  getCustomersAndBrokers: function getCustomersAndBrokers(_ref4, payload) {
    var commit = _ref4.commit;

    if (payload && payload.id) {
      _commonApi2.default.get('' + _endpoint.CUSTOMERSANDBROKERSLIST + payload.id + '/').then(function (response) {
        commit(types.CUSTOMERSANDBROKERSLIST, response);
        if (payload && payload.cbSuccess) payload.cbSuccess();
      }).catch(function (error) {
        console.log(error);
      });
    } else {
      _commonApi2.default.get(_endpoint.CUSTOMERSANDBROKERSLIST).then(function (response) {
        commit(types.CUSTOMERSANDBROKERSLIST, response);
        if (payload && payload.cbSuccess) payload.cbSuccess();
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  getDrms: function getDrms(_ref5) {
    var commit = _ref5.commit;

    _commonApi2.default.get(_endpoint.GETDRMLIST).then(function (response) {
      commit(types.DRMLIST, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getDevs: function getDevs(_ref6) {
    var commit = _ref6.commit;

    _commonApi2.default.get(_endpoint.GETDEVLIST).then(function (response) {
      commit(types.DEVLIST, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  assignRmToUser: function assignRmToUser(_ref7, payload) {
    var _commit = _ref7._commit;

    _commonApi2.default.post('' + _endpoint.AGENTCUSTOMERS + payload.userId + '/', { project_id: payload.projectId }).then(function (response) {
      payload.cbSuccess(response);
    }).catch(function (error) {
      payload.cbError(error);
    });
  },
  getOtherUsers: function getOtherUsers(_ref8, payload) {
    var commit = _ref8.commit;

    var apiUrl = _endpoint.OTHERUSEERS;
    if (payload.projectId) apiUrl = '' + _endpoint.OTHERUSEERS + payload.type + '/' + payload.dev_id + '/' + payload.projectId + '/';else if (payload.dev_id && !payload.projectId) apiUrl = '' + _endpoint.OTHERUSEERS + payload.type + '/' + payload.dev_id + '/';else apiUrl = '' + _endpoint.OTHERUSEERS + payload.type + '/';
    _commonApi2.default.get(apiUrl).then(function (response) {
      commit(types.OTHERUSER, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getRmDetails: function getRmDetails(_ref9, payload) {
    var commit = _ref9.commit;

    _commonApi2.default.get('' + _endpoint.PROJECTRMDETAILS + payload.id + '/').then(function (response) {
      commit(types.PROJECTRMDETAILS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  getBrokerDetails: function getBrokerDetails(_ref10) {
    var commit = _ref10.commit;

    _commonApi2.default.get(_endpoint.BROKERAPPROVALS).then(function (response) {
      commit(types.BROKERAPPROVALS, response);
    }).catch(function (error) {
      console.log(error);
    });
  },
  reviewBroker: function reviewBroker(_ref11, payload) {
    var _commit = _ref11._commit;

    _commonApi2.default.put(_endpoint.BROKERREMARK, payload.data).then(function () {
      if (payload.cb_success) payload.cb_success();
    }).catch(function (error) {
      if (payload.cb_error) payload.cb_error(error);
      console.log(error);
    });
  },
  editUsers: function editUsers(_ref12, payload) {
    var dispatch = _ref12.dispatch;

    _commonApi2.default.put(_endpoint.USERS, payload).then(function () {
      dispatch('getUsers');
      if (payload.cb_success) payload.cb_success();
    }).catch(function (error) {
      if (payload.cb_error) payload.cb_error(error);
      console.log(error);
    });
  },
  deleteUser: function deleteUser(_ref13, payload) {
    var dispatch = _ref13.dispatch;

    _commonApi2.default.delete(_endpoint.USERS, payload.userId).then(function () {
      dispatch('getUsers');
    }).catch(function (error) {
      payload.cbError(error);
      console.log(error);
    });
  }
};

exports.default = actions;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  getDevDataList: function getDevDataList(state) {
    return state.devData.developer;
  }
};

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = __webpack_require__(492);

var _actions2 = _interopRequireDefault(_actions);

var _getters = __webpack_require__(493);

var _getters2 = _interopRequireDefault(_getters);

var _mutations = __webpack_require__(495);

var _mutations2 = _interopRequireDefault(_mutations);

var _state = __webpack_require__(496);

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  namespaced: true,
  actions: _actions2.default,
  getters: _getters2.default,
  mutations: _mutations2.default,
  state: _state2.default
};

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _USERS$PROJECTRMDETAI;

var _mutationTypes = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_USERS$PROJECTRMDETAI = {}, (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.USERS, function (state, payload) {
  state.users = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.PROJECTRMDETAILS, function (state, payload) {
  state.projectRmDetails = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.BROKERAPPROVALS, function (state, payload) {
  state.brokers = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.CUSTOMERSANDBROKERSLIST, function (state, payload) {
  state.customersAndBrokersList = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.DRMLIST, function (state, payload) {
  state.drms = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.DEVLIST, function (state, payload) {
  state.devData = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.OTHERUSER, function (state, payload) {
  state.otherUsers = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.STOREFORMULADATA, function (state, payload) {
  state.formulaData = payload;
}), (0, _defineProperty3.default)(_USERS$PROJECTRMDETAI, _mutationTypes.REMOVEFORMULADATA, function (state) {
  state.formulaData = null;
}), _USERS$PROJECTRMDETAI);

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  users: [],
  projectRmDetails: {},
  customersAndBrokersList: [],
  drms: [],
  formulaData: null,
  devData: {},
  otherUsers: [],
  brokers: []
};

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      loaded: false
    };
  },

  methods: {
    syncLocalStorage: function syncLocalStorage(event) {
      if (!event) return;
      if (event.key) {
        if (event.newValue) {
          localStorage.setItem(event.key, event.newValue);
          if (event.key === 'is_internal') {
            if (event.newValue === 'true') {
              this.$router.push({
                name: 'internal.employee.inventory'
              });
            } else if (event.newValue !== 'true') {
              this.$router.push({
                name: 'home.index'
              });
            }
          }
        } else if (event.oldValue && !event.newValue) {
          localStorage.removeItem(event.key);
          if (event.key === 'is_internal') {
            if (event.oldValue === 'true') {
              this.$router.push({
                name: 'internal.login'
              });
            } else if (event.oldValue !== 'true') {
              this.$router.push({
                name: 'home.index',
                query: {
                  login: true
                }
              });
            }
          }
        }
      }
    }
  },
  computed: {
    webSocketConnected: function webSocketConnected() {
      return this.$store.state.socket.socket.isConnected;
    },
    Loader: function Loader() {
      return this.$store.state.master.loader;
    },
    overlayState: function overlayState() {
      return this.$store.state.home.overlayState;
    }
  },

  watch: {
    webSocketConnected: function webSocketConnected(val) {
      if (!val) this.$store.dispatch('socket/connect');
    }
  },

  mounted: function mounted() {
    var _this = this;

    var store = this.$store;
    store.dispatch('auth/check');

    store.dispatch('socket/connect');
    setInterval(function () {
      if (!_this.webSocketConnected) _this.$store.dispatch('socket/connect');
    }, 20000);

    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', function (_event) {
        var currentPath = window.location.hash.slice(1);
        if (store.state.route.path !== currentPath) this.router.push(currentPath);
      }, false);
    }
  },
  created: function created() {
    var _this2 = this;

    window.addEventListener('load', function () {
      _this2.loaded = true;
    });
    window.addEventListener('storage', function (e) {
      _this2.syncLocalStorage(e);
    });
  }
};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 262,
	"./af.js": 262,
	"./ar": 269,
	"./ar-dz": 263,
	"./ar-dz.js": 263,
	"./ar-kw": 264,
	"./ar-kw.js": 264,
	"./ar-ly": 265,
	"./ar-ly.js": 265,
	"./ar-ma": 266,
	"./ar-ma.js": 266,
	"./ar-sa": 267,
	"./ar-sa.js": 267,
	"./ar-tn": 268,
	"./ar-tn.js": 268,
	"./ar.js": 269,
	"./az": 270,
	"./az.js": 270,
	"./be": 271,
	"./be.js": 271,
	"./bg": 272,
	"./bg.js": 272,
	"./bm": 273,
	"./bm.js": 273,
	"./bn": 274,
	"./bn.js": 274,
	"./bo": 275,
	"./bo.js": 275,
	"./br": 276,
	"./br.js": 276,
	"./bs": 277,
	"./bs.js": 277,
	"./ca": 278,
	"./ca.js": 278,
	"./cs": 279,
	"./cs.js": 279,
	"./cv": 280,
	"./cv.js": 280,
	"./cy": 281,
	"./cy.js": 281,
	"./da": 282,
	"./da.js": 282,
	"./de": 285,
	"./de-at": 283,
	"./de-at.js": 283,
	"./de-ch": 284,
	"./de-ch.js": 284,
	"./de.js": 285,
	"./dv": 286,
	"./dv.js": 286,
	"./el": 287,
	"./el.js": 287,
	"./en-au": 288,
	"./en-au.js": 288,
	"./en-ca": 289,
	"./en-ca.js": 289,
	"./en-gb": 290,
	"./en-gb.js": 290,
	"./en-ie": 291,
	"./en-ie.js": 291,
	"./en-il": 292,
	"./en-il.js": 292,
	"./en-nz": 293,
	"./en-nz.js": 293,
	"./eo": 294,
	"./eo.js": 294,
	"./es": 297,
	"./es-do": 295,
	"./es-do.js": 295,
	"./es-us": 296,
	"./es-us.js": 296,
	"./es.js": 297,
	"./et": 298,
	"./et.js": 298,
	"./eu": 299,
	"./eu.js": 299,
	"./fa": 300,
	"./fa.js": 300,
	"./fi": 301,
	"./fi.js": 301,
	"./fo": 302,
	"./fo.js": 302,
	"./fr": 305,
	"./fr-ca": 303,
	"./fr-ca.js": 303,
	"./fr-ch": 304,
	"./fr-ch.js": 304,
	"./fr.js": 305,
	"./fy": 306,
	"./fy.js": 306,
	"./gd": 307,
	"./gd.js": 307,
	"./gl": 308,
	"./gl.js": 308,
	"./gom-latn": 309,
	"./gom-latn.js": 309,
	"./gu": 310,
	"./gu.js": 310,
	"./he": 311,
	"./he.js": 311,
	"./hi": 312,
	"./hi.js": 312,
	"./hr": 313,
	"./hr.js": 313,
	"./hu": 314,
	"./hu.js": 314,
	"./hy-am": 315,
	"./hy-am.js": 315,
	"./id": 316,
	"./id.js": 316,
	"./is": 317,
	"./is.js": 317,
	"./it": 318,
	"./it.js": 318,
	"./ja": 319,
	"./ja.js": 319,
	"./jv": 320,
	"./jv.js": 320,
	"./ka": 321,
	"./ka.js": 321,
	"./kk": 322,
	"./kk.js": 322,
	"./km": 323,
	"./km.js": 323,
	"./kn": 324,
	"./kn.js": 324,
	"./ko": 325,
	"./ko.js": 325,
	"./ky": 326,
	"./ky.js": 326,
	"./lb": 327,
	"./lb.js": 327,
	"./lo": 328,
	"./lo.js": 328,
	"./lt": 329,
	"./lt.js": 329,
	"./lv": 330,
	"./lv.js": 330,
	"./me": 331,
	"./me.js": 331,
	"./mi": 332,
	"./mi.js": 332,
	"./mk": 333,
	"./mk.js": 333,
	"./ml": 334,
	"./ml.js": 334,
	"./mn": 335,
	"./mn.js": 335,
	"./mr": 336,
	"./mr.js": 336,
	"./ms": 338,
	"./ms-my": 337,
	"./ms-my.js": 337,
	"./ms.js": 338,
	"./mt": 339,
	"./mt.js": 339,
	"./my": 340,
	"./my.js": 340,
	"./nb": 341,
	"./nb.js": 341,
	"./ne": 342,
	"./ne.js": 342,
	"./nl": 344,
	"./nl-be": 343,
	"./nl-be.js": 343,
	"./nl.js": 344,
	"./nn": 345,
	"./nn.js": 345,
	"./pa-in": 346,
	"./pa-in.js": 346,
	"./pl": 347,
	"./pl.js": 347,
	"./pt": 349,
	"./pt-br": 348,
	"./pt-br.js": 348,
	"./pt.js": 349,
	"./ro": 350,
	"./ro.js": 350,
	"./ru": 351,
	"./ru.js": 351,
	"./sd": 352,
	"./sd.js": 352,
	"./se": 353,
	"./se.js": 353,
	"./si": 354,
	"./si.js": 354,
	"./sk": 355,
	"./sk.js": 355,
	"./sl": 356,
	"./sl.js": 356,
	"./sq": 357,
	"./sq.js": 357,
	"./sr": 359,
	"./sr-cyrl": 358,
	"./sr-cyrl.js": 358,
	"./sr.js": 359,
	"./ss": 360,
	"./ss.js": 360,
	"./sv": 361,
	"./sv.js": 361,
	"./sw": 362,
	"./sw.js": 362,
	"./ta": 363,
	"./ta.js": 363,
	"./te": 364,
	"./te.js": 364,
	"./tet": 365,
	"./tet.js": 365,
	"./tg": 366,
	"./tg.js": 366,
	"./th": 367,
	"./th.js": 367,
	"./tl-ph": 368,
	"./tl-ph.js": 368,
	"./tlh": 369,
	"./tlh.js": 369,
	"./tr": 370,
	"./tr.js": 370,
	"./tzl": 371,
	"./tzl.js": 371,
	"./tzm": 373,
	"./tzm-latn": 372,
	"./tzm-latn.js": 372,
	"./tzm.js": 373,
	"./ug-cn": 374,
	"./ug-cn.js": 374,
	"./uk": 375,
	"./uk.js": 375,
	"./ur": 376,
	"./ur.js": 376,
	"./uz": 378,
	"./uz-latn": 377,
	"./uz-latn.js": 377,
	"./uz.js": 378,
	"./vi": 379,
	"./vi.js": 379,
	"./x-pseudo": 380,
	"./x-pseudo.js": 380,
	"./yo": 381,
	"./yo.js": 381,
	"./zh-cn": 382,
	"./zh-cn.js": 382,
	"./zh-hk": 383,
	"./zh-hk.js": 383,
	"./zh-tw": 384,
	"./zh-tw.js": 384
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 850;

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(734)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(735)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(733)

var Component = __webpack_require__(51)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 871:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('v-app', {
    class: ("app-content " + (_vm.Loader?'page-loader':'')),
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Here goes home page content")])
},staticRenderFns: []}

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
module.exports = __webpack_require__(390);


/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.router = undefined;

var _vue = __webpack_require__(23);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(878);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(441);

var _routes2 = _interopRequireDefault(_routes);

var _store = __webpack_require__(12);

var _store2 = _interopRequireDefault(_store);

var _commonApi = __webpack_require__(39);

var _commonApi2 = _interopRequireDefault(_commonApi);

var _endpoint = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = exports.router = new _vueRouter2.default({
  routes: _routes2.default,
  mode: 'history',
  scrollBehavior: function scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0 };
  }
});

var navigate = function navigate(to, _from, next) {
  if (to.matched.some(function (m) {
    return m.meta.auth;
  })) {
    if (!_store2.default.state.auth.authenticated) {
      if (to.meta.isInternal) {
        next({
          name: 'internal.login'
        });
      } else {
        next({
          name: 'home.index',
          query: { login: true }
        });
      }
      return;
    }
  }

  if (_store2.default.state.auth.authenticated && !_store2.default.state.auth.isInternal && to.meta.isInternal) {
    var payload = {
      cbSuccess: function cbSuccess() {
        next({
          name: 'internal.login'
        });
      }
    };
    _store2.default.dispatch('auth/logout', payload);
    return;
  }
  if (to.matched.some(function (m) {
    return !m.meta.auth && m.meta.isInternal;
  }) && to.name.includes('internal.login')) {
    if (_store2.default.state.auth.authenticated) {
      if (_store2.default.state.auth.isInternal && _store2.default.state.auth.permissions.broker && _store2.default.state.auth.permissions.broker.length) {
        next({
          name: 'internal.broker.myProjects'
        });
      } else if (_store2.default.state.auth.isInternal) {
        next({
          name: 'internal.employee.inventory'
        });
      }
      return;
    }
  }
  next();
};

router.beforeEach(function (to, from, next) {
  _store2.default.dispatch('auth/check');
  if (!_store2.default.state.master.projectMaster && to.meta.isInternal && _store2.default.state.auth.authenticated && to.meta.auth) {
    _commonApi2.default.get(_endpoint.PROJECTMASTER).then(function (response) {
      var pm = {};
      response.forEach(function (item) {
        pm[item.id] = item;
      });
      _store2.default.dispatch('master/updateProjectMaster', pm);
    }).catch(function (error) {
      console.log(error);
    });
  }
  navigate(to, from, next);
});

_vue2.default.router = router;

exports.default = {
  router: router
};

/***/ })

},[891]);


// WEBPACK FOOTER //
// static/js/app.097cb0760d7154db71dc.js